// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
   VENUE DETAIL — immersive hero · rail nav · booking dock
   ================================================================ */

.fv-page {
  --fv-dock-w: 440px;
  --fv-scroll-track: #e8f4f1;
  --fv-scroll-thumb: #94cfc3;
  background: var(--bv-bg-cream);
  min-height: 100vh;
  overflow-x: clip;
  padding-bottom: calc(var(--bv-space-8) + 80px);
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-base);
  color: var(--bv-ink-2);
  -webkit-font-smoothing: antialiased;
}

.fv-page h1,
.fv-page h2,
.fv-page h3,
.fv-page h4 {
  font-family: var(--bv-font-display);
}

.fv-wrap {
  max-width: var(--bv-container-wide);
  margin-inline: auto;
  padding-inline: var(--bv-container-px);
}

/* —— Two-column page: details left · booking right —— */
.fv-split {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(380px, var(--fv-dock-w));
  gap: 0;
  max-width: calc(var(--bv-container-wide) + 2 * var(--bv-container-px));
  margin-inline: auto;
  padding-inline: var(--bv-container-px);
  align-items: start;
}

.fv-split__main {
  min-width: 0;
  padding-right: var(--bv-space-6);
  border-right: 1px solid var(--bv-line-soft);
}

.fv-split__main .fv-hero {
  --fv-slider-w: min(550px, 100%);
}

.fv-split__book {
  position: sticky;
  top: calc(72px + 12px);
  align-self: start;
  z-index: 25;
  padding: var(--bv-space-4) 0 var(--bv-space-8) var(--bv-space-6);
  min-height: calc(100dvh - 84px);
}

.fv-split__book .fv-dock {
  position: static;
  top: auto;
}

.fv-split__book .fv-dock__panel {
  max-height: calc(100dvh - 100px);
  box-shadow: var(--bv-shadow-lg);
}

.fv-page .fv-dock__scroll,
.fv-page .fv-content {
  scrollbar-width: thin;
  scrollbar-color: var(--fv-scroll-thumb) var(--fv-scroll-track);
}

.fv-page .fv-dock__scroll::-webkit-scrollbar,
.fv-page .fv-content::-webkit-scrollbar {
  width: 4px;
}

.fv-page .fv-dock__scroll::-webkit-scrollbar-thumb,
.fv-page .fv-content::-webkit-scrollbar-thumb {
  background: var(--fv-scroll-thumb);
  border-radius: 100px;
}

/* —— Venue banner (matches af-hero / BookVenue theme) —— */
.fv-hero {
  --fv-slider-w: 550px;
  --fv-slider-h: 250px;
  position: relative;
  padding: var(--bv-space-4) 0;
  background: transparent;
}

.fv-hero__inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-3);
}

.fv-hero__panel {
  padding: var(--bv-space-4) var(--bv-space-5);
  border-radius: var(--bv-radius-xl);
  background: #fff;
  border: 1px solid var(--bv-line);
  box-shadow: var(--bv-shadow-sm);
}

.fv-hero__crumb {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: var(--bv-text-sm);
}

.fv-hero__crumb-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--bv-muted);
  font-weight: 500;
  text-decoration: none;
  transition: color var(--bv-dur) var(--bv-ease);
}

.fv-hero__crumb-link:hover {
  color: var(--bv-primary-700);
}

.fv-hero__crumb-link i {
  font-size: 0.75rem;
  color: var(--bv-primary);
}

.fv-hero__crumb-sep {
  color: var(--bv-muted-2);
  font-size: 0.55rem;
}

.fv-hero__crumb-current {
  color: var(--bv-ink);
  font-weight: 600;
  max-width: 28ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fv-hero__row {
  display: grid;
  grid-template-columns: var(--fv-slider-w) minmax(0, 1fr);
  gap: var(--bv-space-7);
  align-items: stretch;
}

.fv-hero__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--bv-space-3);
  min-width: 0;
  min-height: calc(var(--fv-slider-h) + 60px);
}

.fv-hero__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--bv-space-3);
  width: 100%;
  margin-bottom: var(--bv-space-2);
}

.fv-hero__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  max-width: 100%;
  min-width: 0;
  padding: 5px 12px;
  margin-bottom: 0;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-primary-50);
  border: 1px solid var(--bv-primary-line);
  color: var(--bv-primary-700);
  font-size: var(--bv-text-sm);
  font-weight: 600;
}

.fv-hero__btn--share {
  flex-shrink: 0;
  padding: 5px 12px;
  font-size: var(--bv-text-sm);
  font-weight: 600;
  border-radius: var(--bv-radius-pill);
}

.fv-hero__eyebrow img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.fv-hero__title {
  margin: 0 0 var(--bv-space-2);
  font-family: var(--bv-font-display);
  font-size: clamp(1.35rem, 2.4vw, var(--bv-text-3xl));
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.12;
  color: var(--bv-ink);
}

.fv-hero__loc {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  font-size: var(--bv-text-sm);
  color: var(--bv-muted);
  line-height: 1.5;
}

.fv-hero__loc i {
  margin-top: 3px;
  color: var(--bv-primary);
  flex-shrink: 0;
}

.fv-hero__pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: var(--bv-space-2);
}

.fv-hero__pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: var(--bv-radius-pill);
  background: #fff;
  border: 1px solid var(--bv-line);
  color: var(--bv-ink-2);
  font-size: var(--bv-text-xs);
  font-weight: 600;
  box-shadow: var(--bv-shadow-xs);
}

.fv-hero__pill i {
  color: var(--bv-primary);
  font-size: 0.8rem;
}

.fv-hero__stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: auto;
}

.fv-hero__stat {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--bv-radius-lg);
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
  min-width: 0;
}

.fv-hero__stat i {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: var(--bv-radius);
  background: var(--bv-primary-50);
  border: 1px solid var(--bv-primary-line);
  color: var(--bv-primary-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
}

.fv-hero__stat span {
  display: block;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--bv-muted);
  margin-bottom: 2px;
}

.fv-hero__stat strong {
  display: block;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-sm);
  font-weight: 800;
  color: var(--bv-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fv-hero__footer {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  width: auto;
  max-width: 100%;
  padding-top: var(--bv-space-2);
  border-top: 1px solid var(--bv-line-soft);
}

.fv-hero__btn {
  padding: 10px 16px;
  font-size: var(--bv-text-sm);
  white-space: nowrap;
  width: auto;
  flex: 0 0 auto;
}

.fv-hero__btn--book {
  padding-inline: 18px;
}

/* Image slider */
.fv-hero__visual {
  width: var(--fv-slider-w);
  max-width: 100%;
  min-width: 0;
}

.fv-hero__slider {
  position: relative;
  width: var(--fv-slider-w);
  max-width: 100%;
  height: var(--fv-slider-h);
  border-radius: var(--bv-radius-lg);
  overflow: hidden;
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-primary-line);
  box-shadow: var(--bv-shadow-sm);
}

.fv-hero__slide {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  cursor: pointer;
  background: var(--bv-bg-soft);
}

.fv-hero__slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.fv-hero__slide--empty {
  display: grid;
  place-items: center;
  cursor: default;
  background: var(--bv-grad-soft);
}

.fv-hero__slide--empty img {
  width: 72px;
  height: 72px;
  object-fit: contain;
  opacity: 0.5;
}

.fv-hero__nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  width: 36px;
  height: 36px;
  border: 1px solid var(--bv-primary-line);
  border-radius: 50%;
  background: #fff;
  color: var(--bv-primary-800);
  box-shadow: var(--bv-shadow-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  opacity: 0;
  transition:
    opacity var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease);
}

.fv-hero__slider:hover .fv-hero__nav,
.fv-hero__slider:focus-within .fv-hero__nav {
  opacity: 1;
}

.fv-hero__nav:hover {
  background: var(--bv-primary-50);
}

.fv-hero__nav--prev {
  left: 10px;
}

.fv-hero__nav--next {
  right: 10px;
}

.fv-hero__count {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  padding: 5px 10px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-grad-primary);
  color: #fff;
  font-size: var(--bv-text-xs);
  font-weight: 700;
  box-shadow: var(--bv-shadow-teal);
}

.fv-hero__gallery {
  position: absolute;
  left: 10px;
  bottom: 10px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border: 1px solid var(--bv-line);
  border-radius: var(--bv-radius-pill);
  background: #fff;
  color: var(--bv-ink-2);
  font-size: var(--bv-text-xs);
  font-weight: 700;
  cursor: pointer;
  box-shadow: var(--bv-shadow-sm);
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}

.fv-hero__gallery:hover {
  border-color: var(--bv-primary-line);
  color: var(--bv-primary-800);
}

.fv-hero__gallery i {
  color: var(--bv-primary);
}

.fv-hero__thumbs {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 6px;
  width: var(--fv-slider-w);
  max-width: 100%;
  margin-top: 8px;
}

.fv-hero__thumbs button {
  width: 100%;
  height: 52px;
  padding: 0;
  border: 2px solid transparent;
  border-radius: var(--bv-radius);
  overflow: hidden;
  cursor: pointer;
  opacity: 0.8;
  transition:
    opacity var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}

.fv-hero__thumbs button img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fv-hero__thumbs button.is-active {
  opacity: 1;
  border-color: var(--bv-primary);
  box-shadow: 0 0 0 3px var(--bv-primary-50);
}

/* —— Stage layout —— */
.fv-stage {
  padding: var(--bv-space-5) 0 var(--bv-space-10);
}

.fv-stage__layout {
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-5);
  min-width: 0;
}

/* Horizontal section tabs (top) */
.fv-side-nav {
  position: sticky;
  top: calc(80px + 8px);
  z-index: 20;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 6px;
  margin: 0;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scrollbar-width: none;
  border-radius: var(--bv-radius-xl);
  background: #fff;
  border: 1px solid var(--bv-line);
  box-shadow: var(--bv-shadow-sm);
  -webkit-overflow-scrolling: touch;
}

.fv-side-nav::-webkit-scrollbar {
  display: none;
}

.fv-side-nav__btn {
  flex: 0 0 auto;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: var(--bv-radius-pill);
  background: transparent;
  color: var(--bv-muted);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}

.fv-side-nav__btn i {
  font-size: 0.9rem;
  color: var(--bv-primary);
  transition: color var(--bv-dur) var(--bv-ease);
}

.fv-side-nav__btn:hover {
  background: var(--bv-bg-soft);
  color: var(--bv-primary-800);
}

.fv-side-nav__btn.is-active {
  background: var(--bv-grad-primary);
  color: #fff;
  box-shadow: var(--bv-shadow-teal);
}

.fv-side-nav__btn.is-active i {
  color: #fff;
}

/* —— Venue content sections —— */
.fv-content {
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-4);
  min-width: 0;
}

.fv-section {
  scroll-margin-top: calc(72px + 72px);
  padding: var(--bv-space-5);
  border-radius: var(--bv-radius-xl);
  background: #fff;
  border: 1px solid var(--bv-line-soft);
  box-shadow: var(--bv-shadow-xs);
}

.fv-section__head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: var(--bv-space-4);
  padding-bottom: var(--bv-space-3);
  border-bottom: 1px solid var(--bv-line-soft);
}

.fv-section__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: var(--bv-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
  color: var(--bv-primary);
  font-size: 0.95rem;
}

.fv-section__titles {
  flex: 1 1;
  min-width: 0;
}

.fv-section__titles h2 {
  margin: 0 0 4px;
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-base);
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--bv-ink);
  line-height: 1.3;
}

.fv-section__desc {
  margin: 0;
  font-size: var(--bv-text-sm);
  font-weight: 500;
  color: var(--bv-muted);
  line-height: 1.4;
}

.fv-section__badge {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-primary-50);
  border: 1px solid var(--bv-primary-line);
  font-size: var(--bv-text-xs);
  font-weight: 600;
  color: var(--bv-primary-800);
  line-height: 1.2;
}

.fv-section__body {
  min-height: 0;
}

/* About — read more / view less */
.fv-about.has-toggle .fv-about__clip {
  position: relative;
  max-height: 8.75rem;
  overflow: hidden;
  transition: max-height 0.4s var(--bv-ease);
}

.fv-about.has-toggle.is-expanded .fv-about__clip {
  max-height: 4000px;
}

.fv-about.has-toggle:not(.is-expanded) .fv-about__clip::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3.5rem;
  background: linear-gradient(180deg, transparent 0%, #fff 88%);
  pointer-events: none;
}

.fv-prose {
  font-size: var(--bv-text-sm);
  font-weight: 500;
  line-height: 1.75;
  color: var(--bv-ink-2);
}

.fv-prose p {
  margin: 0;
  white-space: pre-line;
}

.fv-about__toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: var(--bv-space-3);
  padding: 0;
  border: none;
  background: none;
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  color: var(--bv-primary-700);
  cursor: pointer;
  transition: color var(--bv-dur) var(--bv-ease);
}

.fv-about__toggle:hover {
  color: var(--bv-primary-800);
}

.fv-about__toggle i {
  font-size: 0.7rem;
  transition: transform var(--bv-dur) var(--bv-ease);
}

/* —— Booking dock —— */
.fv-dock {
  min-width: 0;
}

.fv-dock__panel {
  /* Unified booking form type scale (13px base) */
  --fv-book-xs: 0.6875rem;
  --fv-book-sm: 0.75rem;
  --fv-book-md: 0.8125rem;
  --fv-book-lg: 0.875rem;
  font-family: var(--bv-font-body);
  font-size: var(--fv-book-md);
  line-height: 1.35;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 96px);
  border-radius: var(--bv-radius-2xl);
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--bv-line);
  box-shadow: var(--bv-shadow-lg);
}

.fv-dock__panel--compact .fv-dock__head {
  padding: var(--bv-space-3) var(--bv-space-4);
}

.fv-dock__panel--compact .fv-dock__venue {
  font-size: var(--fv-book-md);
}

.fv-dock__panel--compact .fv-dock__stepper-item {
  padding: 6px 4px;
}

.fv-dock__panel--compact .fv-dock__scroll {
  padding: var(--bv-space-4);
}

.fv-dock__panel--compact .fv-dock__step-caption {
  margin-bottom: var(--bv-space-2);
}

.fv-dock__panel--compact .fv-dock__bar {
  padding: var(--bv-space-3) var(--bv-space-4);
}

.fv-dock__panel--compact .fv-dock__pill {
  padding: 6px 8px;
}

.fv-dock__panel--compact .fv-dock__pay-btn {
  min-height: 42px;
}

/* Booking dock header */
.fv-dock__head {
  flex-shrink: 0;
  padding: var(--bv-space-4);
  background: #fff;
  border-bottom: 1px solid var(--bv-line-soft);
}

.fv-dock__venue {
  margin: 0 0 var(--bv-space-3);
  font-family: var(--bv-font-body);
  font-size: var(--fv-book-lg);
  font-weight: 600;
  color: var(--bv-ink);
  letter-spacing: -0.02em;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: center;
}

/* Stepper — same shell as .fv-times__tabs / .fv-dock__summary */
.fv-dock__stepper {
  --fv-booking-progress: 0%;
  list-style: none;
  margin: 0;
  padding: 4px;
  display: flex;
  gap: 4px;
  position: relative;
  border-radius: var(--bv-radius-lg);
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
  overflow: hidden;
}

.fv-dock__stepper::before {
  content: "";
  position: absolute;
  left: 4px;
  bottom: 4px;
  height: 2px;
  width: var(--fv-booking-progress);
  max-width: calc(100% - 8px);
  border-radius: var(--bv-radius-pill);
  background: var(--bv-primary);
  opacity: 0.35;
  transition: width var(--bv-dur) var(--bv-ease);
  pointer-events: none;
}

.fv-dock__stepper-item {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 4px;
  border: 1px solid transparent;
  border-radius: var(--bv-radius);
  text-align: center;
  transition:
    background var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}

.fv-dock__stepper-icon {
  width: 24px;
  height: 24px;
  border-radius: var(--bv-radius-pill);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid var(--bv-line);
  color: var(--bv-muted);
  font-size: 0.7rem;
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}

.fv-dock__stepper-label {
  font-family: var(--bv-font-body);
  font-size: var(--fv-book-xs);
  font-weight: 500;
  color: var(--bv-muted);
  line-height: 1.2;
}

.fv-dock__stepper-item.is-current {
  background: #fff;
  border-color: var(--bv-primary-line);
  box-shadow: var(--bv-shadow-xs);
}

.fv-dock__stepper-item.is-current .fv-dock__stepper-icon {
  border-color: var(--bv-primary);
  background: var(--bv-primary-50);
  color: var(--bv-primary);
}

.fv-dock__stepper-item.is-current .fv-dock__stepper-label {
  font-weight: 600;
  color: var(--bv-primary-800);
}

.fv-dock__stepper-item.is-done .fv-dock__stepper-icon {
  border-color: var(--bv-primary);
  background: var(--bv-grad-primary);
  color: #fff;
  font-size: 0.55rem;
}

.fv-dock__stepper-item.is-done .fv-dock__stepper-label {
  color: var(--bv-primary-700);
}

.fv-dock__scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: var(--bv-space-4) var(--bv-space-5);
  background: #fff;
}

.fv-dock__step-caption {
  margin: 0 0 var(--bv-space-3);
  font-size: var(--fv-book-sm);
  font-weight: 500;
  color: var(--bv-muted);
}

.fv-dock__form {
  min-height: 0;
  font-size: var(--fv-book-md);
}

/* —— Activity: horizontal scroll chips —— */
.fv-wizard__panel--activity {
  margin: 0 -2px;
}

.fv-activity-rail {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 2px 2px 10px;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.fv-activity-rail::-webkit-scrollbar {
  display: none;
}

.fv-activity-chip {
  flex: 0 0 auto;
  scroll-snap-align: start;
  width: 76px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 10px 8px 9px;
  border: 1.5px solid var(--bv-line);
  border-radius: 14px;
  background: #fff;
  cursor: pointer;
  font-family: var(--bv-font-body);
  transition:
    border-color 0.2s var(--bv-ease),
    background 0.2s var(--bv-ease),
    transform 0.2s var(--bv-ease);
}

.fv-activity-chip:hover:not(:disabled) {
  border-color: var(--bv-primary-line);
  transform: translateY(-1px);
}

.fv-activity-chip.is-selected {
  border-color: var(--bv-primary);
  background: var(--bv-primary-50);
}

.fv-activity-chip:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none;
}

.fv-activity-chip__media {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fv-activity-chip__media img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.fv-activity-chip.is-selected .fv-activity-chip__media {
  background: #fff;
  border-color: var(--bv-primary-line);
}

.fv-activity-chip__label {
  width: 100%;
  font-size: var(--fv-book-xs);
  font-weight: 600;
  color: var(--bv-ink-2);
  line-height: 1.2;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.fv-activity-chip.is-selected .fv-activity-chip__label {
  color: var(--bv-primary-800);
}

/* —— Courts: horizontal scroll cards —— */
.fv-wizard__panel--court {
  margin: 0 -2px;
}

.fv-court-rail {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 2px 2px 10px;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.fv-court-rail::-webkit-scrollbar {
  display: none;
}

.fv-court-chip {
  flex: 0 0 auto;
  scroll-snap-align: start;
  min-width: 9.5rem;
  max-width: 11.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 12px 14px;
  border: 1.5px solid var(--bv-line);
  border-radius: 14px;
  background: #fff;
  cursor: pointer;
  font-family: var(--bv-font-body);
  text-align: left;
  transition:
    border-color 0.2s var(--bv-ease),
    background 0.2s var(--bv-ease),
    transform 0.2s var(--bv-ease);
}

.fv-court-chip:hover {
  border-color: var(--bv-primary-line);
  transform: translateY(-1px);
}

.fv-court-chip.is-selected {
  border-color: var(--bv-primary);
  background: var(--bv-primary-50);
}

.fv-court-chip__name {
  font-size: var(--fv-book-md);
  font-weight: 600;
  color: var(--bv-ink);
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.fv-court-chip.is-selected .fv-court-chip__name {
  color: var(--bv-primary-800);
}

.fv-court-chip__price {
  font-size: var(--fv-book-sm);
  font-weight: 700;
  color: var(--bv-primary-700);
  line-height: 1.2;
}

.fv-court-chip__unit {
  font-weight: 500;
  color: var(--bv-muted);
  font-size: var(--fv-book-xs);
}

/* Time slot step — scoped in booking dock */
.fv-wizard__panel--time .fv-times {
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-3);
}

.fv-times__tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 4px;
  border-radius: var(--bv-radius-lg);
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
}

.fv-times__tab {
  flex: 1 1 auto;
  min-width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 7px 12px;
  border: 1px solid transparent;
  border-radius: var(--bv-radius);
  background: transparent;
  color: var(--bv-muted);
  font-family: var(--bv-font-body);
  font-size: var(--fv-book-sm);
  font-weight: 500;
  line-height: 1.2;
  cursor: pointer;
  transition:
    background var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}

.fv-times__tab i {
  font-size: 0.75rem;
  opacity: 0.85;
}

.fv-times__tab:hover:not(.is-active) {
  background: #fff;
  color: var(--bv-ink-2);
}

.fv-times__tab.is-active {
  background: #fff;
  border-color: var(--bv-primary-line);
  color: var(--bv-primary-800);
  font-weight: 600;
  box-shadow: var(--bv-shadow-xs);
}

.fv-times__tab.is-active i {
  color: var(--bv-primary);
  opacity: 1;
}

/* Time slots — horizontal chip grid */
.fv-times__picker {
  border-radius: var(--bv-radius-lg);
  border: 1px solid var(--bv-line);
  background: #fff;
  overflow: hidden;
}

.fv-times__row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px;
  max-height: min(200px, 36vh);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.fv-times__slot {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.333% - 6px);
  min-width: 5.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 9px 8px;
  border: 1px solid var(--bv-line);
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  font-family: var(--bv-font-body);
  text-align: center;
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}

.fv-times__slot-label {
  font-variant-numeric: tabular-nums;
  font-size: var(--fv-book-xs);
  font-weight: 500;
  color: var(--bv-ink-2);
  line-height: 1.25;
  letter-spacing: -0.01em;
}

.fv-times__slot:hover:not(:disabled):not(.is-selected) {
  border-color: var(--bv-primary-line);
  background: var(--bv-bg-soft);
}

.fv-times__slot.is-selected {
  border-color: var(--bv-primary);
  background: var(--bv-primary-50);
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--bv-primary) 25%, transparent);
}

.fv-times__slot.is-selected .fv-times__slot-label {
  color: var(--bv-primary-800);
  font-weight: 600;
}

.fv-times__slot.is-disabled {
  cursor: not-allowed;
  opacity: 0.42;
  background: var(--bv-bg-soft);
}

.fv-times__slot.is-disabled .fv-times__slot-label {
  text-decoration: line-through;
  color: var(--bv-muted);
}

.fv-dock__panel .fv-dock__form .fv-times__slot-label {
  font-size: var(--fv-book-sm);
}

.fv-times__picker-foot {
  margin: 0;
  padding: 8px 12px;
  border-top: 1px solid var(--bv-line-soft);
  background: var(--bv-bg-soft);
  font-size: var(--fv-book-xs);
  font-weight: 500;
  color: var(--bv-muted);
  text-align: center;
}

.fv-dock__panel .fv-dock__form .fv-wizard__empty {
  padding: var(--bv-space-3);
  font-size: var(--fv-book-sm);
}

/* Booking dock footer — matches fv-times__tab pattern */
.fv-dock__bar {
  flex-shrink: 0;
  padding: var(--bv-space-3) var(--bv-space-4) var(--bv-space-4);
  background: #fff;
  border-top: 1px solid var(--bv-line-soft);
}

/* Summary pills (same shell as .fv-times__tabs) */
.fv-dock__summary {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 4px;
  margin-bottom: var(--bv-space-3);
  border-radius: var(--bv-radius-lg);
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
}

.fv-dock__pill {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 3px);
  min-width: 7rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border: 1px solid transparent;
  border-radius: var(--bv-radius);
  background: transparent;
  color: var(--bv-muted);
  font-family: var(--bv-font-body);
  transition:
    background var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}

.fv-dock__pill i {
  flex-shrink: 0;
  font-size: 0.75rem;
  opacity: 0.85;
}

.fv-dock__pill-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.2;
}

.fv-dock__pill-name {
  font-size: var(--fv-book-xs);
  font-weight: 500;
  color: var(--bv-muted);
}

.fv-dock__pill-value {
  font-size: var(--fv-book-sm);
  font-weight: 500;
  color: var(--bv-ink-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fv-dock__pill.is-set {
  background: #fff;
  border-color: var(--bv-primary-line);
  color: var(--bv-primary-800);
  box-shadow: var(--bv-shadow-xs);
}

.fv-dock__pill.is-set i {
  color: var(--bv-primary);
  opacity: 1;
}

.fv-dock__pill.is-set .fv-dock__pill-name {
  color: var(--bv-muted);
}

.fv-dock__pill.is-set .fv-dock__pill-value {
  font-weight: 600;
  color: var(--bv-primary-800);
}

/* Pay row */
.fv-dock__pay {
  display: flex;
  align-items: center;
  gap: 10px;
}

.fv-dock__pay-meta {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 4.5rem;
}

.fv-dock__pay-label {
  font-family: var(--bv-font-body);
  font-size: var(--fv-book-sm);
  font-weight: 500;
  color: var(--bv-muted);
  line-height: 1.2;
}

.fv-dock__pay-amount {
  font-family: var(--bv-font-body);
  font-size: var(--fv-book-lg);
  font-weight: 600;
  color: var(--bv-ink);
  letter-spacing: -0.02em;
  line-height: 1.1;
}

.fv-dock__pay-actions {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.fv-dock__pay-clear {
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid var(--bv-line);
  border-radius: var(--bv-radius);
  background: #fff;
  color: var(--bv-muted);
  font-size: var(--fv-book-sm);
  cursor: pointer;
  transition:
    color var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease);
}

.fv-dock__pay-clear:hover {
  color: var(--bv-primary-700);
  border-color: var(--bv-primary-line);
  background: var(--bv-bg-soft);
}

.fv-dock__pay-btn {
  flex: 1 1;
  min-width: 0;
  min-height: 42px;
  padding: 10px 16px;
  border: none;
  border-radius: var(--bv-radius);
  background: var(--bv-grad-primary);
  color: #fff;
  font-family: var(--bv-font-body);
  font-size: var(--fv-book-sm);
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  box-shadow: var(--bv-shadow-teal);
  transition:
    transform var(--bv-dur) var(--bv-ease),
    opacity var(--bv-dur) var(--bv-ease);
}

.fv-dock__pay-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.fv-dock__pay-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.fv-dock__note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: var(--bv-space-3) 0 0;
  padding-top: var(--bv-space-2);
  border-top: 1px solid var(--bv-line-soft);
  font-family: var(--bv-font-body);
  font-size: var(--fv-book-xs);
  font-weight: 500;
  color: var(--bv-muted);
  line-height: 1.3;
}

.fv-dock__note i {
  font-size: 0.65rem;
  color: var(--bv-primary);
  opacity: 0.9;
}

/* Buttons (shared) */
.fv-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: var(--bv-radius-lg);
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-sm);
  font-weight: 700;
  cursor: pointer;
  border: none;
  transition: all var(--bv-dur) var(--bv-ease);
}

.fv-btn--primary {
  background: var(--bv-grad-primary);
  color: #fff;
  box-shadow: var(--bv-shadow-teal);
}

.fv-btn--ghost {
  background: #fff;
  border: 1px solid var(--bv-line);
  color: var(--bv-ink-2);
}

.fv-btn--block {
  width: 100%;
}

/* Calendar */
.fv-page .fv-calendar.react-calendar {
  width: 100% !important;
  max-width: 100%;
  border: none;
  border-radius: var(--bv-radius-xl);
  padding: var(--bv-space-3);
  font-family: var(--bv-font-body);
  background: var(--bv-bg-soft);
  line-height: 1.25;
}

.fv-page .fv-calendar button {
  border: 0;
  background: none;
  font-family: inherit;
}

.fv-page .fv-calendar .react-calendar__navigation {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 44px;
  margin-bottom: var(--bv-space-3);
  padding: 4px 6px;
  background: #fff;
  border: 1px solid var(--bv-line);
  border-radius: var(--bv-radius-lg);
}

.fv-page .fv-calendar .react-calendar__navigation button {
  min-width: 34px;
  height: 34px;
  border-radius: var(--bv-radius);
  font-weight: 700;
  color: var(--bv-ink-2);
}

.fv-page .fv-calendar .react-calendar__navigation button:enabled:hover {
  background: var(--bv-primary-50);
  color: var(--bv-primary-800);
}

.fv-page .fv-calendar .react-calendar__navigation__label {
  flex: 1 1;
  font-family: var(--bv-font-display);
  font-weight: 800;
  color: var(--bv-ink);
  pointer-events: none;
}

.fv-page .fv-calendar .react-calendar__navigation__prev2-button,
.fv-page .fv-calendar .react-calendar__navigation__next2-button {
  display: none;
}

.fv-page .fv-calendar .react-calendar__month-view__weekdays {
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.62rem;
  letter-spacing: 0.08em;
  color: var(--bv-muted);
  margin-bottom: var(--bv-space-2);
}

.fv-page .fv-calendar .react-calendar__month-view__weekdays abbr {
  text-decoration: none;
}

.fv-page .fv-calendar .react-calendar__month-view__days {
  display: grid !important;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
}

.fv-page .fv-calendar .react-calendar__tile {
  font-size: var(--bv-text-sm);
  font-weight: 600;
  padding: 0;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--bv-radius);
  color: var(--bv-ink-2);
}

.fv-page .fv-calendar .react-calendar__tile:enabled:hover {
  background: var(--bv-primary-50);
  color: var(--bv-primary-800);
}

.fv-page .fv-calendar .react-calendar__tile:disabled {
  opacity: 0.4;
}

.fv-page .fv-calendar .react-calendar__tile--now {
  box-shadow: inset 0 0 0 2px var(--bv-primary-line);
  background: var(--bv-primary-50);
}

.fv-page .fv-calendar .react-calendar__tile--active,
.fv-page .fv-calendar .react-calendar__tile--active:enabled:hover {
  background: var(--bv-grad-primary) !important;
  color: #fff !important;
  box-shadow: var(--bv-shadow-teal);
}

.fv-dock__panel .fv-calendar.react-calendar {
  padding: var(--bv-space-2);
  background: #fff;
  border: 1px solid var(--bv-line-soft);
  font-size: var(--fv-book-md);
}

.fv-dock__panel .fv-calendar .react-calendar__navigation {
  height: 34px;
  margin-bottom: var(--bv-space-2);
  padding: 2px 4px;
}

.fv-dock__panel .fv-calendar .react-calendar__navigation button {
  min-width: 28px;
  height: 28px;
  font-size: var(--fv-book-sm);
}

.fv-dock__panel .fv-calendar .react-calendar__navigation__label {
  font-family: var(--bv-font-body);
  font-size: var(--fv-book-lg);
  font-weight: 700;
}

.fv-dock__panel .fv-calendar .react-calendar__month-view__weekdays {
  font-size: var(--fv-book-xs);
  margin-bottom: 4px;
}

.fv-dock__panel .fv-calendar .react-calendar__month-view__days {
  gap: 3px;
}

.fv-dock__panel .fv-calendar .react-calendar__tile {
  font-size: var(--fv-book-md);
  font-weight: 600;
  aspect-ratio: 1;
  max-height: 32px;
  border-radius: var(--bv-radius-sm);
}

/* Wizard choices */
.fv-wizard__empty {
  text-align: center;
  padding: var(--bv-space-5);
  margin: 0;
  color: var(--bv-muted);
  font-size: var(--bv-text-sm);
  background: var(--bv-bg-soft);
  border-radius: var(--bv-radius-lg);
  border: 1px dashed var(--bv-line);
}

.fv-choice-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.fv-choice {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: var(--bv-space-3);
  border: 2px solid var(--bv-line);
  border-radius: var(--bv-radius-lg);
  background: var(--bv-bg-soft);
  cursor: pointer;
  transition: all var(--bv-dur) var(--bv-ease);
}

.fv-choice:hover:not(:disabled) {
  border-color: var(--bv-primary-line);
}

.fv-choice.is-selected {
  border-color: var(--bv-primary);
  background: var(--bv-primary-50);
  box-shadow: var(--bv-shadow-teal);
}

.fv-choice:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.fv-choice__img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid var(--bv-line);
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fv-choice__img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.fv-choice__label {
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-sm);
  font-weight: 700;
  text-align: center;
  color: var(--bv-ink);
}

.fv-court-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.fv-court-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  padding: var(--bv-space-3) var(--bv-space-4);
  text-align: left;
  border: 2px solid var(--bv-line);
  border-radius: var(--bv-radius-lg);
  background: #fff;
  cursor: pointer;
  transition: all var(--bv-dur) var(--bv-ease);
}

.fv-court-card strong {
  font-family: var(--bv-font-display);
  font-weight: 700;
  color: var(--bv-ink);
}

.fv-court-card span {
  font-size: var(--bv-text-sm);
  color: var(--bv-muted);
}

.fv-court-card.is-selected {
  border-color: var(--bv-primary);
  background: var(--bv-primary-50);
}

/* Amenities grid */
.fv-amenity-grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(7.5rem, 1fr));
  gap: 10px;
}

.fv-amenity-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 14px 10px;
  border-radius: var(--bv-radius);
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
  text-align: center;
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease);
}

.fv-amenity-card:hover {
  border-color: var(--bv-primary-line);
  background: var(--bv-primary-50);
}

.fv-amenity-card__icon {
  width: 40px;
  height: 40px;
  border-radius: var(--bv-radius);
  background: #fff;
  border: 1px solid var(--bv-line-soft);
  color: var(--bv-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}

.fv-amenity-card__name {
  font-size: var(--bv-text-xs);
  font-weight: 600;
  color: var(--bv-ink-2);
  line-height: 1.3;
}

/* Gallery */
.fv-gallery__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-rows: 112px;
  gap: 8px;
}

.fv-gallery__cell {
  position: relative;
  grid-column: span 1;
  grid-row: span 1;
  border: none;
  padding: 0;
  border-radius: var(--bv-radius);
  overflow: hidden;
  cursor: pointer;
  background: var(--bv-bg-soft);
}

.fv-gallery__cell--feature {
  grid-column: span 2;
  grid-row: span 2;
}

.fv-gallery__cell img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.35s var(--bv-ease-out);
}

.fv-gallery__cell:hover img {
  transform: scale(1.04);
}

.fv-gallery__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0);
  color: #fff;
  font-size: 1rem;
  opacity: 0;
  transition:
    opacity var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease);
}

.fv-gallery__cell:hover .fv-gallery__overlay {
  opacity: 1;
  background: rgba(15, 23, 42, 0.32);
}

/* Reviews */
.fv-reviews-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: var(--bv-space-4);
  padding: 12px 14px;
  border-radius: var(--bv-radius);
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
}

.fv-reviews-summary__score {
  display: flex;
  align-items: center;
  gap: 10px;
}

.fv-reviews-summary__score strong {
  font-family: var(--bv-font-body);
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--bv-primary-800);
  letter-spacing: -0.02em;
  line-height: 1;
}

.fv-reviews-summary__count {
  font-size: var(--bv-text-sm);
  font-weight: 500;
  color: var(--bv-muted);
}

.fv-reviews {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.fv-review-card {
  padding: 14px;
  border-radius: var(--bv-radius);
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line-soft);
}

.fv-review-card__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.fv-review-card__avatar {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--bv-grad-primary);
  color: #fff;
  font-size: var(--bv-text-sm);
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fv-review-card__meta {
  flex: 1 1;
  min-width: 0;
}

.fv-review-card__meta strong {
  display: block;
  font-size: var(--bv-text-sm);
  font-weight: 600;
  color: var(--bv-ink);
}

.fv-review-card__meta time {
  display: block;
  font-size: var(--bv-text-xs);
  font-weight: 500;
  color: var(--bv-muted);
  margin-top: 2px;
}

.fv-review-card__stars {
  flex-shrink: 0;
}

.fv-review-card__body {
  margin: 0;
  font-size: var(--bv-text-sm);
  font-weight: 500;
  line-height: 1.65;
  color: var(--bv-ink-2);
}

.fv-empty-state {
  text-align: center;
  padding: var(--bv-space-6) var(--bv-space-4);
  border-radius: var(--bv-radius);
  background: var(--bv-bg-soft);
  border: 1px dashed var(--bv-line);
}

.fv-empty-state--error p {
  color: var(--bv-danger);
  font-size: var(--bv-text-sm);
  font-weight: 500;
}

.fv-empty-state__icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid var(--bv-line-soft);
  color: var(--bv-primary);
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  margin-bottom: var(--bv-space-2);
}

.fv-empty-state p {
  margin: 0;
  font-size: var(--bv-text-sm);
  font-weight: 500;
  color: var(--bv-muted);
}

/* Map */
.fv-map-card {
  border-radius: var(--bv-radius-lg);
  overflow: hidden;
  border: 1px solid var(--bv-line-soft);
  background: var(--bv-bg-soft);
}

.fv-map-card__frame {
  line-height: 0;
}

.fv-map-card__frame iframe {
  width: 100%;
  height: 240px;
  border: 0;
  display: block;
}

.fv-map-card__footer {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  background: #fff;
  border-top: 1px solid var(--bv-line-soft);
}

.fv-map-card__footer i {
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--bv-primary);
  font-size: 0.9rem;
}

.fv-map-card__footer p {
  margin: 0;
  font-size: var(--bv-text-sm);
  font-weight: 500;
  line-height: 1.55;
  color: var(--bv-ink-2);
}

/* Nearby — horizontal compact cards */
.fv-nearby-rail {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  margin: 0 -2px;
  padding: 2px 2px 8px;
  overflow-x: auto;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.fv-nearby-rail::-webkit-scrollbar {
  display: none;
}

.fv-nearby-rail__item {
  flex: 0 0 auto;
  scroll-snap-align: start;
  width: min(11.5rem, 42vw);
}

.fv-nearby-chip {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  border: 1px solid var(--bv-line-soft);
  border-radius: var(--bv-radius-lg);
  overflow: hidden;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}

.fv-nearby-chip:hover {
  border-color: var(--bv-primary-line);
  box-shadow: var(--bv-shadow-sm);
  transform: translateY(-2px);
}

.fv-nearby-chip__img {
  position: relative;
  display: block;
  aspect-ratio: 5 / 3;
  min-height: 96px;
  background: var(--bv-bg-soft);
  overflow: hidden;
}

.fv-nearby-chip__img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.fv-nearby-chip__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 96px;
  color: var(--bv-muted-2);
  font-size: 1.35rem;
}

.fv-nearby-chip__dist {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 3px 8px;
  border-radius: var(--bv-radius-pill);
  background: rgba(15, 23, 42, 0.72);
  color: #fff;
  font-size: var(--bv-text-xs);
  font-weight: 600;
  line-height: 1.2;
}

.fv-nearby-chip__body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px 11px;
}

.fv-nearby-chip__name {
  font-size: var(--bv-text-sm);
  font-weight: 600;
  color: var(--bv-ink);
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.fv-nearby-chip__foot {
  display: flex;
  align-items: center;
  min-height: 1.25rem;
}

.fv-nearby-chip__price {
  font-size: var(--bv-text-xs);
  font-weight: 600;
  color: var(--bv-primary-800);
}

.fv-nearby-chip__link {
  font-size: var(--bv-text-xs);
  font-weight: 600;
  color: var(--bv-primary-700);
}

.fv-empty {
  margin: 0;
  padding: var(--bv-space-5);
  text-align: center;
  font-size: var(--bv-text-sm);
  color: var(--bv-muted);
  background: var(--bv-bg-soft);
  border-radius: var(--bv-radius-lg);
  border: 1px dashed var(--bv-line);
}

/* Mobile bar */
.fv-mobile-bar {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 12px var(--bv-container-px);
  gap: 12px;
  align-items: center;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(12px);
  border-top: 1px solid var(--bv-line);
}

.fv-mobile-bar__price {
  flex-shrink: 0;
}

.fv-mobile-bar__price span {
  display: block;
  font-size: var(--bv-text-xs);
  color: var(--bv-muted);
}

.fv-mobile-bar__price strong {
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-lg);
  color: var(--bv-primary-800);
}

.fv-mobile-bar button {
  flex: 1 1;
  padding: 14px;
  border: none;
  border-radius: var(--bv-radius-lg);
  background: var(--bv-grad-primary);
  color: #fff;
  font-weight: 700;
  box-shadow: var(--bv-shadow-teal);
}

/* Checkout — mobile-app bottom sheet */
.fv-checkout-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0;
}

.fv-checkout-sheet {
  width: 100%;
  max-width: 560px;
  max-height: 92vh;
  height: auto;
  background: var(--bv-bg-soft);
  border-radius: var(--bv-radius-2xl) var(--bv-radius-2xl) 0 0;
  box-shadow: 0 -12px 48px rgba(15, 23, 42, 0.2);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-sm);
  animation: fvSheetUp 0.35s var(--bv-ease-out) both;
}

@keyframes fvSheetUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fv-checkout-sheet__handle {
  flex-shrink: 0;
  width: 40px;
  height: 4px;
  margin: 10px auto 4px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-line);
}

.fv-checkout-sheet__bar {
  flex-shrink: 0;
  display: grid;
  grid-template-columns: 72px 1fr 40px;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 12px;
  background: var(--bv-bg-soft);
}

.fv-checkout-sheet__close {
  justify-self: end;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: #fff;
  color: var(--bv-ink-2);
  box-shadow: var(--bv-shadow-xs);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background var(--bv-dur) var(--bv-ease);
}

.fv-checkout-sheet__close:hover {
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
}

.fv-checkout-sheet__title {
  margin: 0;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-base);
  font-weight: 800;
  color: var(--bv-ink);
  text-align: center;
  letter-spacing: -0.02em;
}

.fv-checkout-sheet__badge {
  justify-self: start;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-primary-50);
  border: 1px solid var(--bv-primary-line);
  color: var(--bv-primary-700);
  font-size: 0.65rem;
  font-weight: 700;
}

.fv-checkout-sheet__badge i {
  font-size: 0.6rem;
}

.fv-checkout-sheet__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: var(--bv-line) transparent;
  padding: 4px 20px 12px;
}

.fv-checkout-sheet__body::-webkit-scrollbar {
  width: 6px;
}

.fv-checkout-sheet__body::-webkit-scrollbar-thumb {
  background: var(--bv-line);
  border-radius: 3px;
}

.fv-checkout-sheet__scroll--center,
.fv-checkout-sheet__body--center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

/* Venue hero card */
.fv-checkout-card {
  display: flex;
  gap: 14px;
  padding: 14px 16px;
  margin-bottom: 12px;
  background: #fff;
  border-radius: var(--bv-radius-xl);
  border: 1px solid var(--bv-line-soft);
  box-shadow: var(--bv-shadow-xs);
}

.fv-checkout-card__icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: var(--bv-radius-lg);
  background: var(--bv-grad-primary);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  box-shadow: var(--bv-shadow-teal);
}

.fv-checkout-card__eyebrow {
  margin: 0 0 4px;
  font-size: var(--bv-text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--bv-muted);
}

.fv-checkout-card__venue {
  margin: 0 0 6px;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-base);
  font-weight: 800;
  color: var(--bv-ink);
  line-height: 1.25;
  letter-spacing: -0.02em;
}

.fv-checkout-card__meta {
  margin: 0;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: var(--bv-text-xs);
  color: var(--bv-muted);
  line-height: 1.45;
}

.fv-checkout-card__meta i {
  color: var(--bv-primary);
  margin-top: 2px;
  flex-shrink: 0;
}

/* Content blocks */
.fv-checkout-block {
  margin-bottom: 12px;
}

.fv-checkout-block__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px;
  padding: 0 2px;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-sm);
  font-weight: 800;
  color: var(--bv-ink);
  letter-spacing: -0.01em;
}

.fv-checkout-block__count {
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
  font-size: var(--bv-text-xs);
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.fv-checkout-block__hint {
  margin: -4px 0 10px;
  padding: 0 2px;
  font-size: var(--bv-text-xs);
  color: var(--bv-muted);
  line-height: 1.4;
}

.fv-checkout-info {
  list-style: none;
  margin: 0;
  padding: 0;
  background: #fff;
  border-radius: var(--bv-radius-xl);
  border: 1px solid var(--bv-line-soft);
  overflow: hidden;
  box-shadow: var(--bv-shadow-xs);
}

.fv-checkout-info li {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--bv-line-soft);
}

.fv-checkout-info li:last-child {
  border-bottom: none;
}

.fv-checkout-info__icon {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: var(--bv-radius);
  background: var(--bv-bg-soft);
  color: var(--bv-primary-700);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}

.fv-checkout-info__text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.fv-checkout-info__text > span {
  font-size: var(--bv-text-xs);
  font-weight: 600;
  color: var(--bv-muted);
}

.fv-checkout-info__text strong {
  font-size: var(--bv-text-sm);
  font-weight: 700;
  color: var(--bv-ink);
  line-height: 1.35;
}

/* Slot chips — horizontal rail */
.fv-checkout-slots {
  list-style: none;
  margin: 0;
  padding: 0 2px 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  scrollbar-width: thin;
  scrollbar-color: var(--bv-line) transparent;
}

.fv-checkout-slots::-webkit-scrollbar {
  height: 6px;
}

.fv-checkout-slots::-webkit-scrollbar-thumb {
  background: var(--bv-line);
  border-radius: 3px;
}

.fv-checkout-slot {
  flex: 0 0 auto;
  scroll-snap-align: start;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-width: 9.5rem;
  padding: 12px 14px;
  background: #fff;
  border-radius: var(--bv-radius-lg);
  border: 1px solid var(--bv-line-soft);
  box-shadow: var(--bv-shadow-xs);
}

.fv-checkout-slot__time {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--bv-text-sm);
  font-weight: 600;
  color: var(--bv-ink-2);
}

.fv-checkout-slot__time i {
  color: var(--bv-primary);
  font-size: 0.9rem;
}

.fv-checkout-slot__price {
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-base);
  font-weight: 800;
  color: var(--bv-primary-800);
  white-space: nowrap;
}

/* Payment logos — horizontal rail */
.fv-checkout-pay-rail {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
}

.fv-checkout-pay-rail li span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 52px;
  padding: 8px 10px;
  background: #fff;
  border-radius: var(--bv-radius-lg);
  border: 1px solid var(--bv-line-soft);
  box-shadow: var(--bv-shadow-xs);
}

.fv-checkout-pay-rail img {
  display: block;
  height: 36px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

/* Sticky pay dock */
.fv-checkout-sheet__dock {
  flex-shrink: 0;
  padding: 14px 16px calc(16px + env(safe-area-inset-bottom, 0px));
  background: #fff;
  border-top: 1px solid var(--bv-line);
  box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.08);
}

.fv-checkout-dock__row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.fv-checkout-dock__total span {
  display: block;
  font-size: var(--bv-text-xs);
  font-weight: 600;
  color: var(--bv-muted);
  margin-bottom: 2px;
}

.fv-checkout-dock__total strong {
  font-family: var(--bv-font-display);
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--bv-ink);
  letter-spacing: -0.03em;
  line-height: 1;
}

.fv-checkout-dock__slots {
  font-size: var(--bv-text-xs);
  font-weight: 700;
  color: var(--bv-primary-700);
  padding: 6px 10px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-primary-50);
  white-space: nowrap;
}

.fv-checkout-dock__pay {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px 20px;
  font-size: var(--bv-text-base);
  font-weight: 700;
  border-radius: var(--bv-radius-xl);
  box-shadow: var(--bv-shadow-teal);
}

.fv-checkout-dock__trust {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 10px 0 0;
  font-size: var(--bv-text-xs);
  font-weight: 500;
  color: var(--bv-muted);
}

.fv-checkout-dock__trust i {
  color: var(--bv-primary);
  font-size: 0.75rem;
}

.fv-checkout-pay {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.fv-checkout-success {
  text-align: center;
  padding: 20px 8px;
  width: 100%;
}

.fv-checkout-success__icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  margin: 0 auto 12px;
  background: var(--bv-grad-primary);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  box-shadow: var(--bv-shadow-teal);
}

.fv-checkout-success h4 {
  margin: 0 0 6px;
  font-size: var(--bv-text-lg);
  font-weight: 800;
  color: var(--bv-ink);
}

.fv-checkout-success__id {
  margin: 0 0 16px;
  font-size: var(--bv-text-sm);
  color: var(--bv-muted);
}

.fv-checkout-success__id strong {
  color: var(--bv-primary-800);
  font-weight: 700;
}

.success-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.success-popup-box {
  background: #fff;
  padding: 28px;
  border-radius: var(--bv-radius-xl);
  text-align: center;
}

.success-icon {
  font-size: 42px;
  color: var(--bv-success);
}

/* —— Responsive —— */
@media (max-width: 1400px) {
  .fv-page {
    --fv-dock-w: 408px;
  }

  .fv-split__main .fv-hero {
    --fv-slider-w: min(100%, 400px);
    --fv-slider-h: 220px;
  }

  .fv-split__main {
    padding-right: var(--bv-space-5);
  }

  .fv-split__book {
    padding-left: var(--bv-space-4);
  }
}

@media (min-width: 992px) and (max-width: 1280px) {
  .fv-split__main .fv-hero {
    --fv-slider-w: 100%;
  }

  .fv-split__main .fv-hero__row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 1200px) {
  .fv-split__main .fv-hero {
    --fv-slider-w: min(100%, 380px);
  }

  .fv-hero__row {
    grid-template-columns: min(100%, var(--fv-slider-w)) minmax(0, 1fr);
  }

  .fv-split {
    grid-template-columns: minmax(0, 1fr) minmax(360px, var(--fv-dock-w));
  }
}

@media (max-width: 900px) {
  .fv-hero__stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 991px) {
  .fv-page {
    padding-bottom: calc(var(--bv-space-8) + 88px);
  }

  .fv-split {
    grid-template-columns: 1fr;
    padding-inline: 0;
  }

  .fv-split__main {
    border-right: none;
    padding-inline: var(--bv-container-px);
  }

  .fv-split__book {
    order: -1;
    position: static;
    min-height: 0;
    padding: 0;
    margin: 0;
    background: transparent;
  }

  .fv-split__book .fv-dock__panel {
    max-height: none;
    border-radius: 0;
    border-left: none;
    border-right: none;
    box-shadow: none;
    border-top: 1px solid var(--bv-line-soft);
    border-bottom: 1px solid var(--bv-line-soft);
  }

  .fv-hero {
    --fv-slider-w: 100%;
    --fv-slider-h: 220px;
    padding: var(--bv-space-3) 0;
  }

  .fv-hero__panel {
    padding: var(--bv-space-3) var(--bv-space-4);
  }

  .fv-hero__row {
    grid-template-columns: 1fr;
    gap: var(--bv-space-4);
  }

  .fv-hero__content {
    min-height: 0;
  }

  .fv-hero__slider {
    height: var(--fv-slider-h);
  }

  .fv-hero__nav {
    opacity: 1;
  }

  .fv-hero__stats {
    grid-template-columns: 1fr 1fr;
  }

  .fv-hero__top {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .fv-hero__footer {
    display: flex;
    width: 100%;
  }

  .fv-hero__footer .fv-hero__btn {
    flex: 1 1;
    justify-content: center;
  }

  .fv-side-nav {
    top: 64px;
  }

  .fv-side-nav__btn {
    padding: 9px 14px;
    font-size: var(--bv-text-xs);
  }

  .fv-dock__panel {
    max-height: none;
    border-radius: 0;
  }

  .fv-dock__scroll {
    max-height: none;
    overflow: visible;
  }

  .fv-dock__summary {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
  }

  .fv-dock__pill {
    flex: unset;
    min-width: 0;
    width: 100%;
  }

  .fv-section {
    scroll-margin-top: 120px;
    padding: var(--bv-space-4);
  }

  .fv-section__head {
    flex-wrap: wrap;
  }

  .fv-section__badge {
    width: 100%;
    text-align: center;
  }

  .fv-gallery__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: 118px;
  }

  .fv-gallery__cell--feature {
    grid-column: span 2;
    grid-row: span 2;
  }

  .fv-amenity-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .fv-nearby-rail__item {
    width: min(10.5rem, 72vw);
  }

  .fv-mobile-bar {
    display: flex;
  }
}

@media (max-width: 768px) {
  .fv-page {
    font-size: 0.875rem;
    padding-bottom: calc(var(--bv-space-7) + 80px);
  }

  .fv-split__main {
    padding-inline: 16px;
  }

  .fv-hero__title {
    font-size: 1.2rem;
  }

  .fv-hero__panel {
    padding: var(--bv-space-3);
  }

  .fv-section {
    padding: var(--bv-space-3);
    border-radius: var(--bv-radius-lg);
  }

  .fv-section__titles h2 {
    font-size: 0.9375rem;
  }

  .fv-side-nav__btn {
    padding: 8px 12px;
    font-size: 0.75rem;
  }
}

@media (max-width: 640px) {
  .fv-hero {
    padding-block: var(--bv-space-3);
  }

  .fv-hero {
    --fv-slider-h: 200px;
  }

  .fv-hero__thumbs {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .fv-dock__bar {
    padding: var(--bv-space-3);
  }

  .fv-dock__pay {
    flex-direction: column;
    align-items: stretch;
  }

  .fv-dock__pay-meta {
    flex-direction: row;
    align-items: baseline;
    justify-content: space-between;
    min-width: 0;
  }

  .fv-dock__pay-actions {
    width: 100%;
  }

  .fv-dock__pay-btn {
    width: 100%;
  }

  .fv-checkout-sheet {
    max-width: 100%;
    border-radius: var(--bv-radius-2xl) var(--bv-radius-2xl) 0 0;
  }
}

@media (max-width: 480px) {
  .fv-page {
    font-size: 0.8125rem;
  }

  .fv-split__main {
    padding-inline: 12px;
  }

  .fv-hero__title {
    font-size: 1.1rem;
  }

  .fv-hero__stat {
    padding: 8px;
    gap: 8px;
  }

  .fv-hero__stat i {
    width: 28px;
    height: 28px;
    font-size: 0.72rem;
  }

  .fv-dock__panel--compact .fv-dock__head,
  .fv-dock__head {
    padding: var(--bv-space-2) var(--bv-space-3);
  }

  .fv-dock__panel--compact .fv-dock__scroll,
  .fv-dock__scroll {
    padding: var(--bv-space-3);
  }

  .fv-dock__panel--compact .fv-dock__bar,
  .fv-dock__bar {
    padding: var(--bv-space-2) var(--bv-space-3);
  }

  .fv-mobile-bar button {
    padding: 12px;
    font-size: 0.8125rem;
  }
}

@media (min-width: 520px) {
  .fv-checkout-modal {
    align-items: center;
    padding: 20px;
  }

  .fv-checkout-sheet {
    max-width: 560px;
    border-radius: var(--bv-radius-2xl);
    box-shadow: var(--bv-shadow-lg);
  }

  .fv-checkout-sheet__handle {
    display: none;
  }
}

@media (max-width: 400px) {
  .fv-checkout-pay-rail {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    padding-bottom: 4px;
  }

  .fv-checkout-pay-rail::-webkit-scrollbar {
    display: none;
  }

  .fv-checkout-pay-rail li {
    flex: 0 0 auto;
    scroll-snap-align: start;
  }

  .fv-checkout-pay-rail li span {
    width: 80px;
  }
}

@media (min-width: 992px) {
  .fv-page {
    padding-bottom: var(--bv-space-10);
  }

  .fv-hero__btn--book {
    display: none;
  }

  .fv-mobile-bar {
    display: none;
  }
}
/* Hide breadcrumb only on mobile */
@media (max-width: 767px) {
  .fv-hero__crumb {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/facilityDetail.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,qEAAqE;EACrE,MAAM;EACN,sEAAsE;EACtE,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,gEAAgE;EAChE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;;EAEE,qBAAqB;EACrB,8DAA8D;AAChE;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA,2DAA2D;AAC3D;EACE,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;EAClC,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,gCAAgC;EAChC,wCAAwC;EACxC,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,oDAAoD;EACpD,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;EAC7B,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;EAChC,wCAAwC;EACxC,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;EAClC,gBAAgB;EAChB,6BAA6B;EAC7B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV;;2CAEyC;AAC3C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B;;sCAEoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ;;;2CAGyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf;;;2CAGyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;EAClC,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gCAAgC;EAChC,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;EAChC,wCAAwC;EACxC,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,6DAA6D;EAC7D,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA,uBAAuB;AACvB;EACE,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;EAC7B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,aAAa;EACb,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB;;;sCAGoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,iBAAiB;EACjB;;;sCAGoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC;;;iCAG+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,0CAA0C;AAC1C;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB;;;iCAG+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;;;sCAGoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA,sCAAsC;AACtC;EACE,kCAAkC;EAClC,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,YAA6B;EAA7B,cAA6B;EAA7B,+BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB;;;;0CAIwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,4EAA4E;AAC9E;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,yCAAyC;EACzC,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,wDAAwD;AACxD;EACE,cAAc;EACd,8DAA8D;EAC9D,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,kCAAkC;EAClC,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC;;;sCAGoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf;;;2CAGyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,WAAW;EACX,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC;;wCAEsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;EACzC,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA,aAAa;AACb;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,kCAAkC;EAClC,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,mCAAmC;EACnC,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,gCAAgC;AAClC;;AAEA;;EAEE,6CAA6C;EAC7C,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS;EACT,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,gCAAgC;EAChC,kCAAkC;EAClC,6BAA6B;EAC7B,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,6DAA6D;EAC7D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB;;2CAEyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;EACrC,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,gDAAgD;EAChD,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,UAAU;EACV;;2CAEyC;AAC3C;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,+BAA+B;EAC/B,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,QAAQ;AACR;EACE,kCAAkC;EAClC,gBAAgB;EAChB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,qCAAqC;EACrC,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;;;0CAGwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;EAClC,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,kCAAkC;EAClC,kCAAkC;EAClC,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,4DAA4D;EAC5D,8CAA8C;EAC9C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;EAChC,wCAAwC;EACxC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,4BAA4B;EAC5B,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kCAAkC;EAClC,qCAAqC;EACrC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;EAC7B,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,gEAAgE;EAChE,gBAAgB;EAChB,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,+BAA+B;IAC/B,oBAAoB;EACtB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,qEAAqE;EACvE;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,8CAA8C;EAChD;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,4CAA4C;EAC9C;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,4BAA4B;EAC9B;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,gDAAgD;IAChD,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,8CAA8C;EAChD;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;;IAEE,4CAA4C;EAC9C;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mCAAmC;IACnC,+BAA+B;EACjC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,iCAAiC;IACjC,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;AACA,mCAAmC;AACnC;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* ================================================================\n   VENUE DETAIL — immersive hero · rail nav · booking dock\n   ================================================================ */\n\n.fv-page {\n  --fv-dock-w: 440px;\n  --fv-scroll-track: #e8f4f1;\n  --fv-scroll-thumb: #94cfc3;\n  background: var(--bv-bg-cream);\n  min-height: 100vh;\n  overflow-x: clip;\n  padding-bottom: calc(var(--bv-space-8) + 80px);\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-base);\n  color: var(--bv-ink-2);\n  -webkit-font-smoothing: antialiased;\n}\n\n.fv-page h1,\n.fv-page h2,\n.fv-page h3,\n.fv-page h4 {\n  font-family: var(--bv-font-display);\n}\n\n.fv-wrap {\n  max-width: var(--bv-container-wide);\n  margin-inline: auto;\n  padding-inline: var(--bv-container-px);\n}\n\n/* —— Two-column page: details left · booking right —— */\n.fv-split {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(380px, var(--fv-dock-w));\n  gap: 0;\n  max-width: calc(var(--bv-container-wide) + 2 * var(--bv-container-px));\n  margin-inline: auto;\n  padding-inline: var(--bv-container-px);\n  align-items: start;\n}\n\n.fv-split__main {\n  min-width: 0;\n  padding-right: var(--bv-space-6);\n  border-right: 1px solid var(--bv-line-soft);\n}\n\n.fv-split__main .fv-hero {\n  --fv-slider-w: min(550px, 100%);\n}\n\n.fv-split__book {\n  position: sticky;\n  top: calc(72px + 12px);\n  align-self: start;\n  z-index: 25;\n  padding: var(--bv-space-4) 0 var(--bv-space-8) var(--bv-space-6);\n  min-height: calc(100dvh - 84px);\n}\n\n.fv-split__book .fv-dock {\n  position: static;\n  top: auto;\n}\n\n.fv-split__book .fv-dock__panel {\n  max-height: calc(100dvh - 100px);\n  box-shadow: var(--bv-shadow-lg);\n}\n\n.fv-page .fv-dock__scroll,\n.fv-page .fv-content {\n  scrollbar-width: thin;\n  scrollbar-color: var(--fv-scroll-thumb) var(--fv-scroll-track);\n}\n\n.fv-page .fv-dock__scroll::-webkit-scrollbar,\n.fv-page .fv-content::-webkit-scrollbar {\n  width: 4px;\n}\n\n.fv-page .fv-dock__scroll::-webkit-scrollbar-thumb,\n.fv-page .fv-content::-webkit-scrollbar-thumb {\n  background: var(--fv-scroll-thumb);\n  border-radius: 100px;\n}\n\n/* —— Venue banner (matches af-hero / BookVenue theme) —— */\n.fv-hero {\n  --fv-slider-w: 550px;\n  --fv-slider-h: 250px;\n  position: relative;\n  padding: var(--bv-space-4) 0;\n  background: transparent;\n}\n\n.fv-hero__inner {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-3);\n}\n\n.fv-hero__panel {\n  padding: var(--bv-space-4) var(--bv-space-5);\n  border-radius: var(--bv-radius-xl);\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  box-shadow: var(--bv-shadow-sm);\n}\n\n.fv-hero__crumb {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: var(--bv-text-sm);\n}\n\n.fv-hero__crumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--bv-muted);\n  font-weight: 500;\n  text-decoration: none;\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n\n.fv-hero__crumb-link:hover {\n  color: var(--bv-primary-700);\n}\n\n.fv-hero__crumb-link i {\n  font-size: 0.75rem;\n  color: var(--bv-primary);\n}\n\n.fv-hero__crumb-sep {\n  color: var(--bv-muted-2);\n  font-size: 0.55rem;\n}\n\n.fv-hero__crumb-current {\n  color: var(--bv-ink);\n  font-weight: 600;\n  max-width: 28ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.fv-hero__row {\n  display: grid;\n  grid-template-columns: var(--fv-slider-w) minmax(0, 1fr);\n  gap: var(--bv-space-7);\n  align-items: stretch;\n}\n\n.fv-hero__content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--bv-space-3);\n  min-width: 0;\n  min-height: calc(var(--fv-slider-h) + 60px);\n}\n\n.fv-hero__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--bv-space-3);\n  width: 100%;\n  margin-bottom: var(--bv-space-2);\n}\n\n.fv-hero__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  width: fit-content;\n  max-width: 100%;\n  min-width: 0;\n  padding: 5px 12px;\n  margin-bottom: 0;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-primary-50);\n  border: 1px solid var(--bv-primary-line);\n  color: var(--bv-primary-700);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n}\n\n.fv-hero__btn--share {\n  flex-shrink: 0;\n  padding: 5px 12px;\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  border-radius: var(--bv-radius-pill);\n}\n\n.fv-hero__eyebrow img {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n}\n\n.fv-hero__title {\n  margin: 0 0 var(--bv-space-2);\n  font-family: var(--bv-font-display);\n  font-size: clamp(1.35rem, 2.4vw, var(--bv-text-3xl));\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.12;\n  color: var(--bv-ink);\n}\n\n.fv-hero__loc {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0;\n  font-size: var(--bv-text-sm);\n  color: var(--bv-muted);\n  line-height: 1.5;\n}\n\n.fv-hero__loc i {\n  margin-top: 3px;\n  color: var(--bv-primary);\n  flex-shrink: 0;\n}\n\n.fv-hero__pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: var(--bv-space-2);\n}\n\n.fv-hero__pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  border-radius: var(--bv-radius-pill);\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  color: var(--bv-ink-2);\n  font-size: var(--bv-text-xs);\n  font-weight: 600;\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.fv-hero__pill i {\n  color: var(--bv-primary);\n  font-size: 0.8rem;\n}\n\n.fv-hero__stats {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  margin-top: auto;\n}\n\n.fv-hero__stat {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n  min-width: 0;\n}\n\n.fv-hero__stat i {\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border-radius: var(--bv-radius);\n  background: var(--bv-primary-50);\n  border: 1px solid var(--bv-primary-line);\n  color: var(--bv-primary-700);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n}\n\n.fv-hero__stat span {\n  display: block;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--bv-muted);\n  margin-bottom: 2px;\n}\n\n.fv-hero__stat strong {\n  display: block;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-sm);\n  font-weight: 800;\n  color: var(--bv-ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.fv-hero__footer {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  width: auto;\n  max-width: 100%;\n  padding-top: var(--bv-space-2);\n  border-top: 1px solid var(--bv-line-soft);\n}\n\n.fv-hero__btn {\n  padding: 10px 16px;\n  font-size: var(--bv-text-sm);\n  white-space: nowrap;\n  width: auto;\n  flex: 0 0 auto;\n}\n\n.fv-hero__btn--book {\n  padding-inline: 18px;\n}\n\n/* Image slider */\n.fv-hero__visual {\n  width: var(--fv-slider-w);\n  max-width: 100%;\n  min-width: 0;\n}\n\n.fv-hero__slider {\n  position: relative;\n  width: var(--fv-slider-w);\n  max-width: 100%;\n  height: var(--fv-slider-h);\n  border-radius: var(--bv-radius-lg);\n  overflow: hidden;\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-primary-line);\n  box-shadow: var(--bv-shadow-sm);\n}\n\n.fv-hero__slide {\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  background: var(--bv-bg-soft);\n}\n\n.fv-hero__slide img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  display: block;\n}\n\n.fv-hero__slide--empty {\n  display: grid;\n  place-items: center;\n  cursor: default;\n  background: var(--bv-grad-soft);\n}\n\n.fv-hero__slide--empty img {\n  width: 72px;\n  height: 72px;\n  object-fit: contain;\n  opacity: 0.5;\n}\n\n.fv-hero__nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--bv-primary-line);\n  border-radius: 50%;\n  background: #fff;\n  color: var(--bv-primary-800);\n  box-shadow: var(--bv-shadow-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  opacity: 0;\n  transition:\n    opacity var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease);\n}\n\n.fv-hero__slider:hover .fv-hero__nav,\n.fv-hero__slider:focus-within .fv-hero__nav {\n  opacity: 1;\n}\n\n.fv-hero__nav:hover {\n  background: var(--bv-primary-50);\n}\n\n.fv-hero__nav--prev {\n  left: 10px;\n}\n\n.fv-hero__nav--next {\n  right: 10px;\n}\n\n.fv-hero__count {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 2;\n  padding: 5px 10px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-size: var(--bv-text-xs);\n  font-weight: 700;\n  box-shadow: var(--bv-shadow-teal);\n}\n\n.fv-hero__gallery {\n  position: absolute;\n  left: 10px;\n  bottom: 10px;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 12px;\n  border: 1px solid var(--bv-line);\n  border-radius: var(--bv-radius-pill);\n  background: #fff;\n  color: var(--bv-ink-2);\n  font-size: var(--bv-text-xs);\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: var(--bv-shadow-sm);\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n\n.fv-hero__gallery:hover {\n  border-color: var(--bv-primary-line);\n  color: var(--bv-primary-800);\n}\n\n.fv-hero__gallery i {\n  color: var(--bv-primary);\n}\n\n.fv-hero__thumbs {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 6px;\n  width: var(--fv-slider-w);\n  max-width: 100%;\n  margin-top: 8px;\n}\n\n.fv-hero__thumbs button {\n  width: 100%;\n  height: 52px;\n  padding: 0;\n  border: 2px solid transparent;\n  border-radius: var(--bv-radius);\n  overflow: hidden;\n  cursor: pointer;\n  opacity: 0.8;\n  transition:\n    opacity var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n\n.fv-hero__thumbs button img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.fv-hero__thumbs button.is-active {\n  opacity: 1;\n  border-color: var(--bv-primary);\n  box-shadow: 0 0 0 3px var(--bv-primary-50);\n}\n\n/* —— Stage layout —— */\n.fv-stage {\n  padding: var(--bv-space-5) 0 var(--bv-space-10);\n}\n\n.fv-stage__layout {\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-5);\n  min-width: 0;\n}\n\n/* Horizontal section tabs (top) */\n.fv-side-nav {\n  position: sticky;\n  top: calc(80px + 8px);\n  z-index: 20;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  padding: 6px;\n  margin: 0;\n  overflow-x: auto;\n  overscroll-behavior-x: contain;\n  scrollbar-width: none;\n  border-radius: var(--bv-radius-xl);\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  box-shadow: var(--bv-shadow-sm);\n  -webkit-overflow-scrolling: touch;\n}\n\n.fv-side-nav::-webkit-scrollbar {\n  display: none;\n}\n\n.fv-side-nav__btn {\n  flex: 0 0 auto;\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border: none;\n  border-radius: var(--bv-radius-pill);\n  background: transparent;\n  color: var(--bv-muted);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  letter-spacing: 0;\n  text-transform: none;\n  white-space: nowrap;\n  cursor: pointer;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n\n.fv-side-nav__btn i {\n  font-size: 0.9rem;\n  color: var(--bv-primary);\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n\n.fv-side-nav__btn:hover {\n  background: var(--bv-bg-soft);\n  color: var(--bv-primary-800);\n}\n\n.fv-side-nav__btn.is-active {\n  background: var(--bv-grad-primary);\n  color: #fff;\n  box-shadow: var(--bv-shadow-teal);\n}\n\n.fv-side-nav__btn.is-active i {\n  color: #fff;\n}\n\n/* —— Venue content sections —— */\n.fv-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-4);\n  min-width: 0;\n}\n\n.fv-section {\n  scroll-margin-top: calc(72px + 72px);\n  padding: var(--bv-space-5);\n  border-radius: var(--bv-radius-xl);\n  background: #fff;\n  border: 1px solid var(--bv-line-soft);\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.fv-section__head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: var(--bv-space-4);\n  padding-bottom: var(--bv-space-3);\n  border-bottom: 1px solid var(--bv-line-soft);\n}\n\n.fv-section__icon {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--bv-radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n  color: var(--bv-primary);\n  font-size: 0.95rem;\n}\n\n.fv-section__titles {\n  flex: 1;\n  min-width: 0;\n}\n\n.fv-section__titles h2 {\n  margin: 0 0 4px;\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-base);\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--bv-ink);\n  line-height: 1.3;\n}\n\n.fv-section__desc {\n  margin: 0;\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n  color: var(--bv-muted);\n  line-height: 1.4;\n}\n\n.fv-section__badge {\n  flex-shrink: 0;\n  padding: 4px 10px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-primary-50);\n  border: 1px solid var(--bv-primary-line);\n  font-size: var(--bv-text-xs);\n  font-weight: 600;\n  color: var(--bv-primary-800);\n  line-height: 1.2;\n}\n\n.fv-section__body {\n  min-height: 0;\n}\n\n/* About — read more / view less */\n.fv-about.has-toggle .fv-about__clip {\n  position: relative;\n  max-height: 8.75rem;\n  overflow: hidden;\n  transition: max-height 0.4s var(--bv-ease);\n}\n\n.fv-about.has-toggle.is-expanded .fv-about__clip {\n  max-height: 4000px;\n}\n\n.fv-about.has-toggle:not(.is-expanded) .fv-about__clip::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 3.5rem;\n  background: linear-gradient(180deg, transparent 0%, #fff 88%);\n  pointer-events: none;\n}\n\n.fv-prose {\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n  line-height: 1.75;\n  color: var(--bv-ink-2);\n}\n\n.fv-prose p {\n  margin: 0;\n  white-space: pre-line;\n}\n\n.fv-about__toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: var(--bv-space-3);\n  padding: 0;\n  border: none;\n  background: none;\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  color: var(--bv-primary-700);\n  cursor: pointer;\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n\n.fv-about__toggle:hover {\n  color: var(--bv-primary-800);\n}\n\n.fv-about__toggle i {\n  font-size: 0.7rem;\n  transition: transform var(--bv-dur) var(--bv-ease);\n}\n\n/* —— Booking dock —— */\n.fv-dock {\n  min-width: 0;\n}\n\n.fv-dock__panel {\n  /* Unified booking form type scale (13px base) */\n  --fv-book-xs: 0.6875rem;\n  --fv-book-sm: 0.75rem;\n  --fv-book-md: 0.8125rem;\n  --fv-book-lg: 0.875rem;\n  font-family: var(--bv-font-body);\n  font-size: var(--fv-book-md);\n  line-height: 1.35;\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 96px);\n  border-radius: var(--bv-radius-2xl);\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  box-shadow: var(--bv-shadow-lg);\n}\n\n.fv-dock__panel--compact .fv-dock__head {\n  padding: var(--bv-space-3) var(--bv-space-4);\n}\n\n.fv-dock__panel--compact .fv-dock__venue {\n  font-size: var(--fv-book-md);\n}\n\n.fv-dock__panel--compact .fv-dock__stepper-item {\n  padding: 6px 4px;\n}\n\n.fv-dock__panel--compact .fv-dock__scroll {\n  padding: var(--bv-space-4);\n}\n\n.fv-dock__panel--compact .fv-dock__step-caption {\n  margin-bottom: var(--bv-space-2);\n}\n\n.fv-dock__panel--compact .fv-dock__bar {\n  padding: var(--bv-space-3) var(--bv-space-4);\n}\n\n.fv-dock__panel--compact .fv-dock__pill {\n  padding: 6px 8px;\n}\n\n.fv-dock__panel--compact .fv-dock__pay-btn {\n  min-height: 42px;\n}\n\n/* Booking dock header */\n.fv-dock__head {\n  flex-shrink: 0;\n  padding: var(--bv-space-4);\n  background: #fff;\n  border-bottom: 1px solid var(--bv-line-soft);\n}\n\n.fv-dock__venue {\n  margin: 0 0 var(--bv-space-3);\n  font-family: var(--bv-font-body);\n  font-size: var(--fv-book-lg);\n  font-weight: 600;\n  color: var(--bv-ink);\n  letter-spacing: -0.02em;\n  line-height: 1.35;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-align: center;\n}\n\n/* Stepper — same shell as .fv-times__tabs / .fv-dock__summary */\n.fv-dock__stepper {\n  --fv-booking-progress: 0%;\n  list-style: none;\n  margin: 0;\n  padding: 4px;\n  display: flex;\n  gap: 4px;\n  position: relative;\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n  overflow: hidden;\n}\n\n.fv-dock__stepper::before {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  bottom: 4px;\n  height: 2px;\n  width: var(--fv-booking-progress);\n  max-width: calc(100% - 8px);\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-primary);\n  opacity: 0.35;\n  transition: width var(--bv-dur) var(--bv-ease);\n  pointer-events: none;\n}\n\n.fv-dock__stepper-item {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 8px 4px;\n  border: 1px solid transparent;\n  border-radius: var(--bv-radius);\n  text-align: center;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n\n.fv-dock__stepper-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: var(--bv-radius-pill);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  color: var(--bv-muted);\n  font-size: 0.7rem;\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n\n.fv-dock__stepper-label {\n  font-family: var(--bv-font-body);\n  font-size: var(--fv-book-xs);\n  font-weight: 500;\n  color: var(--bv-muted);\n  line-height: 1.2;\n}\n\n.fv-dock__stepper-item.is-current {\n  background: #fff;\n  border-color: var(--bv-primary-line);\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.fv-dock__stepper-item.is-current .fv-dock__stepper-icon {\n  border-color: var(--bv-primary);\n  background: var(--bv-primary-50);\n  color: var(--bv-primary);\n}\n\n.fv-dock__stepper-item.is-current .fv-dock__stepper-label {\n  font-weight: 600;\n  color: var(--bv-primary-800);\n}\n\n.fv-dock__stepper-item.is-done .fv-dock__stepper-icon {\n  border-color: var(--bv-primary);\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-size: 0.55rem;\n}\n\n.fv-dock__stepper-item.is-done .fv-dock__stepper-label {\n  color: var(--bv-primary-700);\n}\n\n.fv-dock__scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: var(--bv-space-4) var(--bv-space-5);\n  background: #fff;\n}\n\n.fv-dock__step-caption {\n  margin: 0 0 var(--bv-space-3);\n  font-size: var(--fv-book-sm);\n  font-weight: 500;\n  color: var(--bv-muted);\n}\n\n.fv-dock__form {\n  min-height: 0;\n  font-size: var(--fv-book-md);\n}\n\n/* —— Activity: horizontal scroll chips —— */\n.fv-wizard__panel--activity {\n  margin: 0 -2px;\n}\n\n.fv-activity-rail {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 10px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 2px 2px 10px;\n  scroll-snap-type: x proximity;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.fv-activity-rail::-webkit-scrollbar {\n  display: none;\n}\n\n.fv-activity-chip {\n  flex: 0 0 auto;\n  scroll-snap-align: start;\n  width: 76px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 8px 9px;\n  border: 1.5px solid var(--bv-line);\n  border-radius: 14px;\n  background: #fff;\n  cursor: pointer;\n  font-family: var(--bv-font-body);\n  transition:\n    border-color 0.2s var(--bv-ease),\n    background 0.2s var(--bv-ease),\n    transform 0.2s var(--bv-ease);\n}\n\n.fv-activity-chip:hover:not(:disabled) {\n  border-color: var(--bv-primary-line);\n  transform: translateY(-1px);\n}\n\n.fv-activity-chip.is-selected {\n  border-color: var(--bv-primary);\n  background: var(--bv-primary-50);\n}\n\n.fv-activity-chip:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.fv-activity-chip__media {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fv-activity-chip__media img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.fv-activity-chip.is-selected .fv-activity-chip__media {\n  background: #fff;\n  border-color: var(--bv-primary-line);\n}\n\n.fv-activity-chip__label {\n  width: 100%;\n  font-size: var(--fv-book-xs);\n  font-weight: 600;\n  color: var(--bv-ink-2);\n  line-height: 1.2;\n  text-align: center;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.fv-activity-chip.is-selected .fv-activity-chip__label {\n  color: var(--bv-primary-800);\n}\n\n/* —— Courts: horizontal scroll cards —— */\n.fv-wizard__panel--court {\n  margin: 0 -2px;\n}\n\n.fv-court-rail {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 10px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 2px 2px 10px;\n  scroll-snap-type: x proximity;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.fv-court-rail::-webkit-scrollbar {\n  display: none;\n}\n\n.fv-court-chip {\n  flex: 0 0 auto;\n  scroll-snap-align: start;\n  min-width: 9.5rem;\n  max-width: 11.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  padding: 12px 14px;\n  border: 1.5px solid var(--bv-line);\n  border-radius: 14px;\n  background: #fff;\n  cursor: pointer;\n  font-family: var(--bv-font-body);\n  text-align: left;\n  transition:\n    border-color 0.2s var(--bv-ease),\n    background 0.2s var(--bv-ease),\n    transform 0.2s var(--bv-ease);\n}\n\n.fv-court-chip:hover {\n  border-color: var(--bv-primary-line);\n  transform: translateY(-1px);\n}\n\n.fv-court-chip.is-selected {\n  border-color: var(--bv-primary);\n  background: var(--bv-primary-50);\n}\n\n.fv-court-chip__name {\n  font-size: var(--fv-book-md);\n  font-weight: 600;\n  color: var(--bv-ink);\n  line-height: 1.25;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.fv-court-chip.is-selected .fv-court-chip__name {\n  color: var(--bv-primary-800);\n}\n\n.fv-court-chip__price {\n  font-size: var(--fv-book-sm);\n  font-weight: 700;\n  color: var(--bv-primary-700);\n  line-height: 1.2;\n}\n\n.fv-court-chip__unit {\n  font-weight: 500;\n  color: var(--bv-muted);\n  font-size: var(--fv-book-xs);\n}\n\n/* Time slot step — scoped in booking dock */\n.fv-wizard__panel--time .fv-times {\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-3);\n}\n\n.fv-times__tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 4px;\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n}\n\n.fv-times__tab {\n  flex: 1 1 auto;\n  min-width: max-content;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 7px 12px;\n  border: 1px solid transparent;\n  border-radius: var(--bv-radius);\n  background: transparent;\n  color: var(--bv-muted);\n  font-family: var(--bv-font-body);\n  font-size: var(--fv-book-sm);\n  font-weight: 500;\n  line-height: 1.2;\n  cursor: pointer;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n\n.fv-times__tab i {\n  font-size: 0.75rem;\n  opacity: 0.85;\n}\n\n.fv-times__tab:hover:not(.is-active) {\n  background: #fff;\n  color: var(--bv-ink-2);\n}\n\n.fv-times__tab.is-active {\n  background: #fff;\n  border-color: var(--bv-primary-line);\n  color: var(--bv-primary-800);\n  font-weight: 600;\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.fv-times__tab.is-active i {\n  color: var(--bv-primary);\n  opacity: 1;\n}\n\n/* Time slots — horizontal chip grid */\n.fv-times__picker {\n  border-radius: var(--bv-radius-lg);\n  border: 1px solid var(--bv-line);\n  background: #fff;\n  overflow: hidden;\n}\n\n.fv-times__row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 10px;\n  max-height: min(200px, 36vh);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.fv-times__slot {\n  flex: 1 1 calc(33.333% - 6px);\n  min-width: 5.75rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 9px 8px;\n  border: 1px solid var(--bv-line);\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n  font-family: var(--bv-font-body);\n  text-align: center;\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n\n.fv-times__slot-label {\n  font-variant-numeric: tabular-nums;\n  font-size: var(--fv-book-xs);\n  font-weight: 500;\n  color: var(--bv-ink-2);\n  line-height: 1.25;\n  letter-spacing: -0.01em;\n}\n\n.fv-times__slot:hover:not(:disabled):not(.is-selected) {\n  border-color: var(--bv-primary-line);\n  background: var(--bv-bg-soft);\n}\n\n.fv-times__slot.is-selected {\n  border-color: var(--bv-primary);\n  background: var(--bv-primary-50);\n  box-shadow: 0 0 0 1px color-mix(in srgb, var(--bv-primary) 25%, transparent);\n}\n\n.fv-times__slot.is-selected .fv-times__slot-label {\n  color: var(--bv-primary-800);\n  font-weight: 600;\n}\n\n.fv-times__slot.is-disabled {\n  cursor: not-allowed;\n  opacity: 0.42;\n  background: var(--bv-bg-soft);\n}\n\n.fv-times__slot.is-disabled .fv-times__slot-label {\n  text-decoration: line-through;\n  color: var(--bv-muted);\n}\n\n.fv-dock__panel .fv-dock__form .fv-times__slot-label {\n  font-size: var(--fv-book-sm);\n}\n\n.fv-times__picker-foot {\n  margin: 0;\n  padding: 8px 12px;\n  border-top: 1px solid var(--bv-line-soft);\n  background: var(--bv-bg-soft);\n  font-size: var(--fv-book-xs);\n  font-weight: 500;\n  color: var(--bv-muted);\n  text-align: center;\n}\n\n.fv-dock__panel .fv-dock__form .fv-wizard__empty {\n  padding: var(--bv-space-3);\n  font-size: var(--fv-book-sm);\n}\n\n/* Booking dock footer — matches fv-times__tab pattern */\n.fv-dock__bar {\n  flex-shrink: 0;\n  padding: var(--bv-space-3) var(--bv-space-4) var(--bv-space-4);\n  background: #fff;\n  border-top: 1px solid var(--bv-line-soft);\n}\n\n/* Summary pills (same shell as .fv-times__tabs) */\n.fv-dock__summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 4px;\n  margin-bottom: var(--bv-space-3);\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n}\n\n.fv-dock__pill {\n  flex: 1 1 calc(50% - 3px);\n  min-width: 7rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  border: 1px solid transparent;\n  border-radius: var(--bv-radius);\n  background: transparent;\n  color: var(--bv-muted);\n  font-family: var(--bv-font-body);\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n\n.fv-dock__pill i {\n  flex-shrink: 0;\n  font-size: 0.75rem;\n  opacity: 0.85;\n}\n\n.fv-dock__pill-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  line-height: 1.2;\n}\n\n.fv-dock__pill-name {\n  font-size: var(--fv-book-xs);\n  font-weight: 500;\n  color: var(--bv-muted);\n}\n\n.fv-dock__pill-value {\n  font-size: var(--fv-book-sm);\n  font-weight: 500;\n  color: var(--bv-ink-2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.fv-dock__pill.is-set {\n  background: #fff;\n  border-color: var(--bv-primary-line);\n  color: var(--bv-primary-800);\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.fv-dock__pill.is-set i {\n  color: var(--bv-primary);\n  opacity: 1;\n}\n\n.fv-dock__pill.is-set .fv-dock__pill-name {\n  color: var(--bv-muted);\n}\n\n.fv-dock__pill.is-set .fv-dock__pill-value {\n  font-weight: 600;\n  color: var(--bv-primary-800);\n}\n\n/* Pay row */\n.fv-dock__pay {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.fv-dock__pay-meta {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 4.5rem;\n}\n\n.fv-dock__pay-label {\n  font-family: var(--bv-font-body);\n  font-size: var(--fv-book-sm);\n  font-weight: 500;\n  color: var(--bv-muted);\n  line-height: 1.2;\n}\n\n.fv-dock__pay-amount {\n  font-family: var(--bv-font-body);\n  font-size: var(--fv-book-lg);\n  font-weight: 600;\n  color: var(--bv-ink);\n  letter-spacing: -0.02em;\n  line-height: 1.1;\n}\n\n.fv-dock__pay-actions {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.fv-dock__pay-clear {\n  width: 42px;\n  height: 42px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid var(--bv-line);\n  border-radius: var(--bv-radius);\n  background: #fff;\n  color: var(--bv-muted);\n  font-size: var(--fv-book-sm);\n  cursor: pointer;\n  transition:\n    color var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease);\n}\n\n.fv-dock__pay-clear:hover {\n  color: var(--bv-primary-700);\n  border-color: var(--bv-primary-line);\n  background: var(--bv-bg-soft);\n}\n\n.fv-dock__pay-btn {\n  flex: 1;\n  min-width: 0;\n  min-height: 42px;\n  padding: 10px 16px;\n  border: none;\n  border-radius: var(--bv-radius);\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-family: var(--bv-font-body);\n  font-size: var(--fv-book-sm);\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  box-shadow: var(--bv-shadow-teal);\n  transition:\n    transform var(--bv-dur) var(--bv-ease),\n    opacity var(--bv-dur) var(--bv-ease);\n}\n\n.fv-dock__pay-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.fv-dock__pay-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.fv-dock__note {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: var(--bv-space-3) 0 0;\n  padding-top: var(--bv-space-2);\n  border-top: 1px solid var(--bv-line-soft);\n  font-family: var(--bv-font-body);\n  font-size: var(--fv-book-xs);\n  font-weight: 500;\n  color: var(--bv-muted);\n  line-height: 1.3;\n}\n\n.fv-dock__note i {\n  font-size: 0.65rem;\n  color: var(--bv-primary);\n  opacity: 0.9;\n}\n\n/* Buttons (shared) */\n.fv-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border-radius: var(--bv-radius-lg);\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  cursor: pointer;\n  border: none;\n  transition: all var(--bv-dur) var(--bv-ease);\n}\n\n.fv-btn--primary {\n  background: var(--bv-grad-primary);\n  color: #fff;\n  box-shadow: var(--bv-shadow-teal);\n}\n\n.fv-btn--ghost {\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  color: var(--bv-ink-2);\n}\n\n.fv-btn--block {\n  width: 100%;\n}\n\n/* Calendar */\n.fv-page .fv-calendar.react-calendar {\n  width: 100% !important;\n  max-width: 100%;\n  border: none;\n  border-radius: var(--bv-radius-xl);\n  padding: var(--bv-space-3);\n  font-family: var(--bv-font-body);\n  background: var(--bv-bg-soft);\n  line-height: 1.25;\n}\n\n.fv-page .fv-calendar button {\n  border: 0;\n  background: none;\n  font-family: inherit;\n}\n\n.fv-page .fv-calendar .react-calendar__navigation {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 44px;\n  margin-bottom: var(--bv-space-3);\n  padding: 4px 6px;\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  border-radius: var(--bv-radius-lg);\n}\n\n.fv-page .fv-calendar .react-calendar__navigation button {\n  min-width: 34px;\n  height: 34px;\n  border-radius: var(--bv-radius);\n  font-weight: 700;\n  color: var(--bv-ink-2);\n}\n\n.fv-page .fv-calendar .react-calendar__navigation button:enabled:hover {\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-800);\n}\n\n.fv-page .fv-calendar .react-calendar__navigation__label {\n  flex: 1;\n  font-family: var(--bv-font-display);\n  font-weight: 800;\n  color: var(--bv-ink);\n  pointer-events: none;\n}\n\n.fv-page .fv-calendar .react-calendar__navigation__prev2-button,\n.fv-page .fv-calendar .react-calendar__navigation__next2-button {\n  display: none;\n}\n\n.fv-page .fv-calendar .react-calendar__month-view__weekdays {\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 0.62rem;\n  letter-spacing: 0.08em;\n  color: var(--bv-muted);\n  margin-bottom: var(--bv-space-2);\n}\n\n.fv-page .fv-calendar .react-calendar__month-view__weekdays abbr {\n  text-decoration: none;\n}\n\n.fv-page .fv-calendar .react-calendar__month-view__days {\n  display: grid !important;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 4px;\n}\n\n.fv-page .fv-calendar .react-calendar__tile {\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  padding: 0;\n  aspect-ratio: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--bv-radius);\n  color: var(--bv-ink-2);\n}\n\n.fv-page .fv-calendar .react-calendar__tile:enabled:hover {\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-800);\n}\n\n.fv-page .fv-calendar .react-calendar__tile:disabled {\n  opacity: 0.4;\n}\n\n.fv-page .fv-calendar .react-calendar__tile--now {\n  box-shadow: inset 0 0 0 2px var(--bv-primary-line);\n  background: var(--bv-primary-50);\n}\n\n.fv-page .fv-calendar .react-calendar__tile--active,\n.fv-page .fv-calendar .react-calendar__tile--active:enabled:hover {\n  background: var(--bv-grad-primary) !important;\n  color: #fff !important;\n  box-shadow: var(--bv-shadow-teal);\n}\n\n.fv-dock__panel .fv-calendar.react-calendar {\n  padding: var(--bv-space-2);\n  background: #fff;\n  border: 1px solid var(--bv-line-soft);\n  font-size: var(--fv-book-md);\n}\n\n.fv-dock__panel .fv-calendar .react-calendar__navigation {\n  height: 34px;\n  margin-bottom: var(--bv-space-2);\n  padding: 2px 4px;\n}\n\n.fv-dock__panel .fv-calendar .react-calendar__navigation button {\n  min-width: 28px;\n  height: 28px;\n  font-size: var(--fv-book-sm);\n}\n\n.fv-dock__panel .fv-calendar .react-calendar__navigation__label {\n  font-family: var(--bv-font-body);\n  font-size: var(--fv-book-lg);\n  font-weight: 700;\n}\n\n.fv-dock__panel .fv-calendar .react-calendar__month-view__weekdays {\n  font-size: var(--fv-book-xs);\n  margin-bottom: 4px;\n}\n\n.fv-dock__panel .fv-calendar .react-calendar__month-view__days {\n  gap: 3px;\n}\n\n.fv-dock__panel .fv-calendar .react-calendar__tile {\n  font-size: var(--fv-book-md);\n  font-weight: 600;\n  aspect-ratio: 1;\n  max-height: 32px;\n  border-radius: var(--bv-radius-sm);\n}\n\n/* Wizard choices */\n.fv-wizard__empty {\n  text-align: center;\n  padding: var(--bv-space-5);\n  margin: 0;\n  color: var(--bv-muted);\n  font-size: var(--bv-text-sm);\n  background: var(--bv-bg-soft);\n  border-radius: var(--bv-radius-lg);\n  border: 1px dashed var(--bv-line);\n}\n\n.fv-choice-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n}\n\n.fv-choice {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: var(--bv-space-3);\n  border: 2px solid var(--bv-line);\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-bg-soft);\n  cursor: pointer;\n  transition: all var(--bv-dur) var(--bv-ease);\n}\n\n.fv-choice:hover:not(:disabled) {\n  border-color: var(--bv-primary-line);\n}\n\n.fv-choice.is-selected {\n  border-color: var(--bv-primary);\n  background: var(--bv-primary-50);\n  box-shadow: var(--bv-shadow-teal);\n}\n\n.fv-choice:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.fv-choice__img {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  padding: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fv-choice__img img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.fv-choice__label {\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  text-align: center;\n  color: var(--bv-ink);\n}\n\n.fv-court-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.fv-court-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  width: 100%;\n  padding: var(--bv-space-3) var(--bv-space-4);\n  text-align: left;\n  border: 2px solid var(--bv-line);\n  border-radius: var(--bv-radius-lg);\n  background: #fff;\n  cursor: pointer;\n  transition: all var(--bv-dur) var(--bv-ease);\n}\n\n.fv-court-card strong {\n  font-family: var(--bv-font-display);\n  font-weight: 700;\n  color: var(--bv-ink);\n}\n\n.fv-court-card span {\n  font-size: var(--bv-text-sm);\n  color: var(--bv-muted);\n}\n\n.fv-court-card.is-selected {\n  border-color: var(--bv-primary);\n  background: var(--bv-primary-50);\n}\n\n/* Amenities grid */\n.fv-amenity-grid {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(7.5rem, 1fr));\n  gap: 10px;\n}\n\n.fv-amenity-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 10px;\n  border-radius: var(--bv-radius);\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n  text-align: center;\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease);\n}\n\n.fv-amenity-card:hover {\n  border-color: var(--bv-primary-line);\n  background: var(--bv-primary-50);\n}\n\n.fv-amenity-card__icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--bv-radius);\n  background: #fff;\n  border: 1px solid var(--bv-line-soft);\n  color: var(--bv-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n}\n\n.fv-amenity-card__name {\n  font-size: var(--bv-text-xs);\n  font-weight: 600;\n  color: var(--bv-ink-2);\n  line-height: 1.3;\n}\n\n/* Gallery */\n.fv-gallery__grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  grid-auto-rows: 112px;\n  gap: 8px;\n}\n\n.fv-gallery__cell {\n  position: relative;\n  grid-column: span 1;\n  grid-row: span 1;\n  border: none;\n  padding: 0;\n  border-radius: var(--bv-radius);\n  overflow: hidden;\n  cursor: pointer;\n  background: var(--bv-bg-soft);\n}\n\n.fv-gallery__cell--feature {\n  grid-column: span 2;\n  grid-row: span 2;\n}\n\n.fv-gallery__cell img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform 0.35s var(--bv-ease-out);\n}\n\n.fv-gallery__cell:hover img {\n  transform: scale(1.04);\n}\n\n.fv-gallery__overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0);\n  color: #fff;\n  font-size: 1rem;\n  opacity: 0;\n  transition:\n    opacity var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease);\n}\n\n.fv-gallery__cell:hover .fv-gallery__overlay {\n  opacity: 1;\n  background: rgba(15, 23, 42, 0.32);\n}\n\n/* Reviews */\n.fv-reviews-summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: var(--bv-space-4);\n  padding: 12px 14px;\n  border-radius: var(--bv-radius);\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n}\n\n.fv-reviews-summary__score {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.fv-reviews-summary__score strong {\n  font-family: var(--bv-font-body);\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--bv-primary-800);\n  letter-spacing: -0.02em;\n  line-height: 1;\n}\n\n.fv-reviews-summary__count {\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n  color: var(--bv-muted);\n}\n\n.fv-reviews {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.fv-review-card {\n  padding: 14px;\n  border-radius: var(--bv-radius);\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line-soft);\n}\n\n.fv-review-card__head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.fv-review-card__avatar {\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fv-review-card__meta {\n  flex: 1;\n  min-width: 0;\n}\n\n.fv-review-card__meta strong {\n  display: block;\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  color: var(--bv-ink);\n}\n\n.fv-review-card__meta time {\n  display: block;\n  font-size: var(--bv-text-xs);\n  font-weight: 500;\n  color: var(--bv-muted);\n  margin-top: 2px;\n}\n\n.fv-review-card__stars {\n  flex-shrink: 0;\n}\n\n.fv-review-card__body {\n  margin: 0;\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n  line-height: 1.65;\n  color: var(--bv-ink-2);\n}\n\n.fv-empty-state {\n  text-align: center;\n  padding: var(--bv-space-6) var(--bv-space-4);\n  border-radius: var(--bv-radius);\n  background: var(--bv-bg-soft);\n  border: 1px dashed var(--bv-line);\n}\n\n.fv-empty-state--error p {\n  color: var(--bv-danger);\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n}\n\n.fv-empty-state__icon {\n  display: inline-flex;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: #fff;\n  border: 1px solid var(--bv-line-soft);\n  color: var(--bv-primary);\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  margin-bottom: var(--bv-space-2);\n}\n\n.fv-empty-state p {\n  margin: 0;\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n  color: var(--bv-muted);\n}\n\n/* Map */\n.fv-map-card {\n  border-radius: var(--bv-radius-lg);\n  overflow: hidden;\n  border: 1px solid var(--bv-line-soft);\n  background: var(--bv-bg-soft);\n}\n\n.fv-map-card__frame {\n  line-height: 0;\n}\n\n.fv-map-card__frame iframe {\n  width: 100%;\n  height: 240px;\n  border: 0;\n  display: block;\n}\n\n.fv-map-card__footer {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 14px 16px;\n  background: #fff;\n  border-top: 1px solid var(--bv-line-soft);\n}\n\n.fv-map-card__footer i {\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: var(--bv-primary);\n  font-size: 0.9rem;\n}\n\n.fv-map-card__footer p {\n  margin: 0;\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n  line-height: 1.55;\n  color: var(--bv-ink-2);\n}\n\n/* Nearby — horizontal compact cards */\n.fv-nearby-rail {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 12px;\n  margin: 0 -2px;\n  padding: 2px 2px 8px;\n  overflow-x: auto;\n  scroll-snap-type: x proximity;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.fv-nearby-rail::-webkit-scrollbar {\n  display: none;\n}\n\n.fv-nearby-rail__item {\n  flex: 0 0 auto;\n  scroll-snap-align: start;\n  width: min(11.5rem, 42vw);\n}\n\n.fv-nearby-chip {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 0;\n  border: 1px solid var(--bv-line-soft);\n  border-radius: var(--bv-radius-lg);\n  overflow: hidden;\n  background: #fff;\n  text-align: left;\n  cursor: pointer;\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n\n.fv-nearby-chip:hover {\n  border-color: var(--bv-primary-line);\n  box-shadow: var(--bv-shadow-sm);\n  transform: translateY(-2px);\n}\n\n.fv-nearby-chip__img {\n  position: relative;\n  display: block;\n  aspect-ratio: 5 / 3;\n  min-height: 96px;\n  background: var(--bv-bg-soft);\n  overflow: hidden;\n}\n\n.fv-nearby-chip__img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.fv-nearby-chip__placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  min-height: 96px;\n  color: var(--bv-muted-2);\n  font-size: 1.35rem;\n}\n\n.fv-nearby-chip__dist {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  padding: 3px 8px;\n  border-radius: var(--bv-radius-pill);\n  background: rgba(15, 23, 42, 0.72);\n  color: #fff;\n  font-size: var(--bv-text-xs);\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.fv-nearby-chip__body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 10px 12px 11px;\n}\n\n.fv-nearby-chip__name {\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  color: var(--bv-ink);\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.fv-nearby-chip__foot {\n  display: flex;\n  align-items: center;\n  min-height: 1.25rem;\n}\n\n.fv-nearby-chip__price {\n  font-size: var(--bv-text-xs);\n  font-weight: 600;\n  color: var(--bv-primary-800);\n}\n\n.fv-nearby-chip__link {\n  font-size: var(--bv-text-xs);\n  font-weight: 600;\n  color: var(--bv-primary-700);\n}\n\n.fv-empty {\n  margin: 0;\n  padding: var(--bv-space-5);\n  text-align: center;\n  font-size: var(--bv-text-sm);\n  color: var(--bv-muted);\n  background: var(--bv-bg-soft);\n  border-radius: var(--bv-radius-lg);\n  border: 1px dashed var(--bv-line);\n}\n\n/* Mobile bar */\n.fv-mobile-bar {\n  display: none;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  padding: 12px var(--bv-container-px);\n  gap: 12px;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.96);\n  backdrop-filter: blur(12px);\n  border-top: 1px solid var(--bv-line);\n}\n\n.fv-mobile-bar__price {\n  flex-shrink: 0;\n}\n\n.fv-mobile-bar__price span {\n  display: block;\n  font-size: var(--bv-text-xs);\n  color: var(--bv-muted);\n}\n\n.fv-mobile-bar__price strong {\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-lg);\n  color: var(--bv-primary-800);\n}\n\n.fv-mobile-bar button {\n  flex: 1;\n  padding: 14px;\n  border: none;\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-weight: 700;\n  box-shadow: var(--bv-shadow-teal);\n}\n\n/* Checkout — mobile-app bottom sheet */\n.fv-checkout-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 0;\n}\n\n.fv-checkout-sheet {\n  width: 100%;\n  max-width: 560px;\n  max-height: 92vh;\n  height: auto;\n  background: var(--bv-bg-soft);\n  border-radius: var(--bv-radius-2xl) var(--bv-radius-2xl) 0 0;\n  box-shadow: 0 -12px 48px rgba(15, 23, 42, 0.2);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-sm);\n  animation: fvSheetUp 0.35s var(--bv-ease-out) both;\n}\n\n@keyframes fvSheetUp {\n  from {\n    opacity: 0;\n    transform: translateY(24px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fv-checkout-sheet__handle {\n  flex-shrink: 0;\n  width: 40px;\n  height: 4px;\n  margin: 10px auto 4px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-line);\n}\n\n.fv-checkout-sheet__bar {\n  flex-shrink: 0;\n  display: grid;\n  grid-template-columns: 72px 1fr 40px;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px 12px;\n  background: var(--bv-bg-soft);\n}\n\n.fv-checkout-sheet__close {\n  justify-self: end;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 50%;\n  background: #fff;\n  color: var(--bv-ink-2);\n  box-shadow: var(--bv-shadow-xs);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background var(--bv-dur) var(--bv-ease);\n}\n\n.fv-checkout-sheet__close:hover {\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n}\n\n.fv-checkout-sheet__title {\n  margin: 0;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-base);\n  font-weight: 800;\n  color: var(--bv-ink);\n  text-align: center;\n  letter-spacing: -0.02em;\n}\n\n.fv-checkout-sheet__badge {\n  justify-self: start;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 10px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-primary-50);\n  border: 1px solid var(--bv-primary-line);\n  color: var(--bv-primary-700);\n  font-size: 0.65rem;\n  font-weight: 700;\n}\n\n.fv-checkout-sheet__badge i {\n  font-size: 0.6rem;\n}\n\n.fv-checkout-sheet__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: var(--bv-line) transparent;\n  padding: 4px 20px 12px;\n}\n\n.fv-checkout-sheet__body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.fv-checkout-sheet__body::-webkit-scrollbar-thumb {\n  background: var(--bv-line);\n  border-radius: 3px;\n}\n\n.fv-checkout-sheet__scroll--center,\n.fv-checkout-sheet__body--center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n}\n\n/* Venue hero card */\n.fv-checkout-card {\n  display: flex;\n  gap: 14px;\n  padding: 14px 16px;\n  margin-bottom: 12px;\n  background: #fff;\n  border-radius: var(--bv-radius-xl);\n  border: 1px solid var(--bv-line-soft);\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.fv-checkout-card__icon {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-grad-primary);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  box-shadow: var(--bv-shadow-teal);\n}\n\n.fv-checkout-card__eyebrow {\n  margin: 0 0 4px;\n  font-size: var(--bv-text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--bv-muted);\n}\n\n.fv-checkout-card__venue {\n  margin: 0 0 6px;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-base);\n  font-weight: 800;\n  color: var(--bv-ink);\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n}\n\n.fv-checkout-card__meta {\n  margin: 0;\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  font-size: var(--bv-text-xs);\n  color: var(--bv-muted);\n  line-height: 1.45;\n}\n\n.fv-checkout-card__meta i {\n  color: var(--bv-primary);\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n/* Content blocks */\n.fv-checkout-block {\n  margin-bottom: 12px;\n}\n\n.fv-checkout-block__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 10px;\n  padding: 0 2px;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-sm);\n  font-weight: 800;\n  color: var(--bv-ink);\n  letter-spacing: -0.01em;\n}\n\n.fv-checkout-block__count {\n  min-width: 22px;\n  height: 22px;\n  padding: 0 7px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n  font-size: var(--bv-text-xs);\n  font-weight: 800;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fv-checkout-block__hint {\n  margin: -4px 0 10px;\n  padding: 0 2px;\n  font-size: var(--bv-text-xs);\n  color: var(--bv-muted);\n  line-height: 1.4;\n}\n\n.fv-checkout-info {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  border-radius: var(--bv-radius-xl);\n  border: 1px solid var(--bv-line-soft);\n  overflow: hidden;\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.fv-checkout-info li {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--bv-line-soft);\n}\n\n.fv-checkout-info li:last-child {\n  border-bottom: none;\n}\n\n.fv-checkout-info__icon {\n  flex-shrink: 0;\n  width: 42px;\n  height: 42px;\n  border-radius: var(--bv-radius);\n  background: var(--bv-bg-soft);\n  color: var(--bv-primary-700);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n}\n\n.fv-checkout-info__text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.fv-checkout-info__text > span {\n  font-size: var(--bv-text-xs);\n  font-weight: 600;\n  color: var(--bv-muted);\n}\n\n.fv-checkout-info__text strong {\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  color: var(--bv-ink);\n  line-height: 1.35;\n}\n\n/* Slot chips — horizontal rail */\n.fv-checkout-slots {\n  list-style: none;\n  margin: 0;\n  padding: 0 2px 4px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 10px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scroll-snap-type: x proximity;\n  scrollbar-width: thin;\n  scrollbar-color: var(--bv-line) transparent;\n}\n\n.fv-checkout-slots::-webkit-scrollbar {\n  height: 6px;\n}\n\n.fv-checkout-slots::-webkit-scrollbar-thumb {\n  background: var(--bv-line);\n  border-radius: 3px;\n}\n\n.fv-checkout-slot {\n  flex: 0 0 auto;\n  scroll-snap-align: start;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  min-width: 9.5rem;\n  padding: 12px 14px;\n  background: #fff;\n  border-radius: var(--bv-radius-lg);\n  border: 1px solid var(--bv-line-soft);\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.fv-checkout-slot__time {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  color: var(--bv-ink-2);\n}\n\n.fv-checkout-slot__time i {\n  color: var(--bv-primary);\n  font-size: 0.9rem;\n}\n\n.fv-checkout-slot__price {\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-base);\n  font-weight: 800;\n  color: var(--bv-primary-800);\n  white-space: nowrap;\n}\n\n/* Payment logos — horizontal rail */\n.fv-checkout-pay-rail {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.fv-checkout-pay-rail li span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 52px;\n  padding: 8px 10px;\n  background: #fff;\n  border-radius: var(--bv-radius-lg);\n  border: 1px solid var(--bv-line-soft);\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.fv-checkout-pay-rail img {\n  display: block;\n  height: 36px;\n  width: auto;\n  max-width: 100%;\n  object-fit: contain;\n}\n\n/* Sticky pay dock */\n.fv-checkout-sheet__dock {\n  flex-shrink: 0;\n  padding: 14px 16px calc(16px + env(safe-area-inset-bottom, 0px));\n  background: #fff;\n  border-top: 1px solid var(--bv-line);\n  box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.08);\n}\n\n.fv-checkout-dock__row {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.fv-checkout-dock__total span {\n  display: block;\n  font-size: var(--bv-text-xs);\n  font-weight: 600;\n  color: var(--bv-muted);\n  margin-bottom: 2px;\n}\n\n.fv-checkout-dock__total strong {\n  font-family: var(--bv-font-display);\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--bv-ink);\n  letter-spacing: -0.03em;\n  line-height: 1;\n}\n\n.fv-checkout-dock__slots {\n  font-size: var(--bv-text-xs);\n  font-weight: 700;\n  color: var(--bv-primary-700);\n  padding: 6px 10px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-primary-50);\n  white-space: nowrap;\n}\n\n.fv-checkout-dock__pay {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 16px 20px;\n  font-size: var(--bv-text-base);\n  font-weight: 700;\n  border-radius: var(--bv-radius-xl);\n  box-shadow: var(--bv-shadow-teal);\n}\n\n.fv-checkout-dock__trust {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: 10px 0 0;\n  font-size: var(--bv-text-xs);\n  font-weight: 500;\n  color: var(--bv-muted);\n}\n\n.fv-checkout-dock__trust i {\n  color: var(--bv-primary);\n  font-size: 0.75rem;\n}\n\n.fv-checkout-pay {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.fv-checkout-success {\n  text-align: center;\n  padding: 20px 8px;\n  width: 100%;\n}\n\n.fv-checkout-success__icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  margin: 0 auto 12px;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  box-shadow: var(--bv-shadow-teal);\n}\n\n.fv-checkout-success h4 {\n  margin: 0 0 6px;\n  font-size: var(--bv-text-lg);\n  font-weight: 800;\n  color: var(--bv-ink);\n}\n\n.fv-checkout-success__id {\n  margin: 0 0 16px;\n  font-size: var(--bv-text-sm);\n  color: var(--bv-muted);\n}\n\n.fv-checkout-success__id strong {\n  color: var(--bv-primary-800);\n  font-weight: 700;\n}\n\n.success-popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.success-popup-box {\n  background: #fff;\n  padding: 28px;\n  border-radius: var(--bv-radius-xl);\n  text-align: center;\n}\n\n.success-icon {\n  font-size: 42px;\n  color: var(--bv-success);\n}\n\n/* —— Responsive —— */\n@media (max-width: 1400px) {\n  .fv-page {\n    --fv-dock-w: 408px;\n  }\n\n  .fv-split__main .fv-hero {\n    --fv-slider-w: min(100%, 400px);\n    --fv-slider-h: 220px;\n  }\n\n  .fv-split__main {\n    padding-right: var(--bv-space-5);\n  }\n\n  .fv-split__book {\n    padding-left: var(--bv-space-4);\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1280px) {\n  .fv-split__main .fv-hero {\n    --fv-slider-w: 100%;\n  }\n\n  .fv-split__main .fv-hero__row {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 1200px) {\n  .fv-split__main .fv-hero {\n    --fv-slider-w: min(100%, 380px);\n  }\n\n  .fv-hero__row {\n    grid-template-columns: min(100%, var(--fv-slider-w)) minmax(0, 1fr);\n  }\n\n  .fv-split {\n    grid-template-columns: minmax(0, 1fr) minmax(360px, var(--fv-dock-w));\n  }\n}\n\n@media (max-width: 900px) {\n  .fv-hero__stats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 991px) {\n  .fv-page {\n    padding-bottom: calc(var(--bv-space-8) + 88px);\n  }\n\n  .fv-split {\n    grid-template-columns: 1fr;\n    padding-inline: 0;\n  }\n\n  .fv-split__main {\n    border-right: none;\n    padding-inline: var(--bv-container-px);\n  }\n\n  .fv-split__book {\n    order: -1;\n    position: static;\n    min-height: 0;\n    padding: 0;\n    margin: 0;\n    background: transparent;\n  }\n\n  .fv-split__book .fv-dock__panel {\n    max-height: none;\n    border-radius: 0;\n    border-left: none;\n    border-right: none;\n    box-shadow: none;\n    border-top: 1px solid var(--bv-line-soft);\n    border-bottom: 1px solid var(--bv-line-soft);\n  }\n\n  .fv-hero {\n    --fv-slider-w: 100%;\n    --fv-slider-h: 220px;\n    padding: var(--bv-space-3) 0;\n  }\n\n  .fv-hero__panel {\n    padding: var(--bv-space-3) var(--bv-space-4);\n  }\n\n  .fv-hero__row {\n    grid-template-columns: 1fr;\n    gap: var(--bv-space-4);\n  }\n\n  .fv-hero__content {\n    min-height: 0;\n  }\n\n  .fv-hero__slider {\n    height: var(--fv-slider-h);\n  }\n\n  .fv-hero__nav {\n    opacity: 1;\n  }\n\n  .fv-hero__stats {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .fv-hero__top {\n    flex-wrap: wrap;\n    align-items: flex-start;\n  }\n\n  .fv-hero__footer {\n    display: flex;\n    width: 100%;\n  }\n\n  .fv-hero__footer .fv-hero__btn {\n    flex: 1;\n    justify-content: center;\n  }\n\n  .fv-side-nav {\n    top: 64px;\n  }\n\n  .fv-side-nav__btn {\n    padding: 9px 14px;\n    font-size: var(--bv-text-xs);\n  }\n\n  .fv-dock__panel {\n    max-height: none;\n    border-radius: 0;\n  }\n\n  .fv-dock__scroll {\n    max-height: none;\n    overflow: visible;\n  }\n\n  .fv-dock__summary {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 6px;\n  }\n\n  .fv-dock__pill {\n    flex: unset;\n    min-width: 0;\n    width: 100%;\n  }\n\n  .fv-section {\n    scroll-margin-top: 120px;\n    padding: var(--bv-space-4);\n  }\n\n  .fv-section__head {\n    flex-wrap: wrap;\n  }\n\n  .fv-section__badge {\n    width: 100%;\n    text-align: center;\n  }\n\n  .fv-gallery__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    grid-auto-rows: 118px;\n  }\n\n  .fv-gallery__cell--feature {\n    grid-column: span 2;\n    grid-row: span 2;\n  }\n\n  .fv-amenity-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .fv-nearby-rail__item {\n    width: min(10.5rem, 72vw);\n  }\n\n  .fv-mobile-bar {\n    display: flex;\n  }\n}\n\n@media (max-width: 768px) {\n  .fv-page {\n    font-size: 0.875rem;\n    padding-bottom: calc(var(--bv-space-7) + 80px);\n  }\n\n  .fv-split__main {\n    padding-inline: 16px;\n  }\n\n  .fv-hero__title {\n    font-size: 1.2rem;\n  }\n\n  .fv-hero__panel {\n    padding: var(--bv-space-3);\n  }\n\n  .fv-section {\n    padding: var(--bv-space-3);\n    border-radius: var(--bv-radius-lg);\n  }\n\n  .fv-section__titles h2 {\n    font-size: 0.9375rem;\n  }\n\n  .fv-side-nav__btn {\n    padding: 8px 12px;\n    font-size: 0.75rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .fv-hero {\n    padding-block: var(--bv-space-3);\n  }\n\n  .fv-hero {\n    --fv-slider-h: 200px;\n  }\n\n  .fv-hero__thumbs {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .fv-dock__bar {\n    padding: var(--bv-space-3);\n  }\n\n  .fv-dock__pay {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .fv-dock__pay-meta {\n    flex-direction: row;\n    align-items: baseline;\n    justify-content: space-between;\n    min-width: 0;\n  }\n\n  .fv-dock__pay-actions {\n    width: 100%;\n  }\n\n  .fv-dock__pay-btn {\n    width: 100%;\n  }\n\n  .fv-checkout-sheet {\n    max-width: 100%;\n    border-radius: var(--bv-radius-2xl) var(--bv-radius-2xl) 0 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .fv-page {\n    font-size: 0.8125rem;\n  }\n\n  .fv-split__main {\n    padding-inline: 12px;\n  }\n\n  .fv-hero__title {\n    font-size: 1.1rem;\n  }\n\n  .fv-hero__stat {\n    padding: 8px;\n    gap: 8px;\n  }\n\n  .fv-hero__stat i {\n    width: 28px;\n    height: 28px;\n    font-size: 0.72rem;\n  }\n\n  .fv-dock__panel--compact .fv-dock__head,\n  .fv-dock__head {\n    padding: var(--bv-space-2) var(--bv-space-3);\n  }\n\n  .fv-dock__panel--compact .fv-dock__scroll,\n  .fv-dock__scroll {\n    padding: var(--bv-space-3);\n  }\n\n  .fv-dock__panel--compact .fv-dock__bar,\n  .fv-dock__bar {\n    padding: var(--bv-space-2) var(--bv-space-3);\n  }\n\n  .fv-mobile-bar button {\n    padding: 12px;\n    font-size: 0.8125rem;\n  }\n}\n\n@media (min-width: 520px) {\n  .fv-checkout-modal {\n    align-items: center;\n    padding: 20px;\n  }\n\n  .fv-checkout-sheet {\n    max-width: 560px;\n    border-radius: var(--bv-radius-2xl);\n    box-shadow: var(--bv-shadow-lg);\n  }\n\n  .fv-checkout-sheet__handle {\n    display: none;\n  }\n}\n\n@media (max-width: 400px) {\n  .fv-checkout-pay-rail {\n    display: flex;\n    overflow-x: auto;\n    scroll-snap-type: x mandatory;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    padding-bottom: 4px;\n  }\n\n  .fv-checkout-pay-rail::-webkit-scrollbar {\n    display: none;\n  }\n\n  .fv-checkout-pay-rail li {\n    flex: 0 0 auto;\n    scroll-snap-align: start;\n  }\n\n  .fv-checkout-pay-rail li span {\n    width: 80px;\n  }\n}\n\n@media (min-width: 992px) {\n  .fv-page {\n    padding-bottom: var(--bv-space-10);\n  }\n\n  .fv-hero__btn--book {\n    display: none;\n  }\n\n  .fv-mobile-bar {\n    display: none;\n  }\n}\n/* Hide breadcrumb only on mobile */\n@media (max-width: 767px) {\n  .fv-hero__crumb {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
